"use strict";

let isRunnedSelects = false;
// DEBOUNCE FUNCTION START
const debounce = (callback, wait) => {
  let timeoutId = null;
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback.apply(null, args);
    }, wait);
  };
};
// DEBOUNCE FUNCTION END
let mobileMenu = null;

// Inject YouTube API script
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/player_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
// global variable for the player
var player;
let players = [];

// this function gets called when API is ready to use
function onYouTubePlayerAPIReady() {
  // create the global player from the specific iframe (#video)
  player = new YT.Player('video', {

  });
  const wrappers = Array.from(document.querySelectorAll("[data-video-id]"));
  wrappers.forEach((wrapper) => {
    const iframe = wrapper.querySelector(".iframe");
    const videoId = wrapper.dataset.videoId;
    if (iframe) {
      const id = iframe.id;
      players.push({
        player: new YT.Player(id, {
          videoId: videoId,
          events: {
            'onStateChange': onPlayerStateChange
          }
        }),
        id: id,
        
      })
    }
  })
}
let done = false;
function onPlayerStateChange(event) {
  //console.log("CHANGE YT")
  //console.log(event)
  //if (event.data == YT.PlayerState.PLAYING && !done) {
  //  done = true;
  //}
  if (event.data === 0) {
    players.forEach((player) => player.player.stopVideo())
  }
}
//const disableBodyScroll = bodyScrollLock.disableBodyScroll;
//const enableBodyScroll = bodyScrollLock.enableBodyScroll;
var disableBodyScroll = (function () {

  /**
   * Private variables
   */
  var _selector = false,
    _element = false,
    _clientY;

  /**
   * Polyfills for Element.matches and Element.closest
   */
  if (!Element.prototype.matches)
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
      Element.prototype.webkitMatchesSelector;

  if (!Element.prototype.closest)
    Element.prototype.closest = function (s) {
      var ancestor = this;
      if (!document.documentElement.contains(el)) return null;
      do {
        if (ancestor.matches(s)) return ancestor;
        ancestor = ancestor.parentElement;
      } while (ancestor !== null);
      return el;
    };

  /**
   * Prevent default unless within _selector
   * 
   * @param  event object event
   * @return void
   */
  var preventBodyScroll = function (event) {
    if (false === _element || !event.target.closest(_selector)) {
      event.preventDefault();
    }
  };

  /**
   * Cache the clientY co-ordinates for
   * comparison
   * 
   * @param  event object event
   * @return void
   */
  var captureClientY = function (event) {
    // only respond to a single touch
    if (event.targetTouches.length === 1) {
      _clientY = event.targetTouches[0].clientY;
    }
  };

  /**
   * Detect whether the element is at the top
   * or the bottom of their scroll and prevent
   * the user from scrolling beyond
   * 
   * @param  event object event
   * @return void
   */
  var preventOverscroll = function (event) {
    // only respond to a single touch
    if (event.targetTouches.length !== 1) {
      return;
    }

    var clientY = event.targetTouches[0].clientY - _clientY;

    // The element at the top of its scroll,
    // and the user scrolls down
    if (_element.scrollTop === 0 && clientY > 0) {
      event.preventDefault();
    }

    // The element at the bottom of its scroll,
    // and the user scrolls up
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
    if ((_element.scrollHeight - _element.scrollTop <= _element.clientHeight) && clientY < 0) {
      event.preventDefault();
    }

  };

  /**
   * Disable body scroll. Scrolling with the selector is
   * allowed if a selector is porvided.
   * 
   * @param  boolean allow
   * @param  string selector Selector to element to change scroll permission
   * @return void
   */
  return function (allow, selector) {
    if (typeof selector !== "undefined") {
      _selector = selector;
      _element = document.querySelector(selector);
    }

    if (true === allow) {
      if (false !== _element) {
        _element.addEventListener('touchstart', captureClientY, false);
        _element.addEventListener('touchmove', preventOverscroll, false);
      }
      document.body.addEventListener("touchmove", preventBodyScroll, false);
    } else {
      if (false !== _element) {
        _element.removeEventListener('touchstart', captureClientY, false);
        _element.removeEventListener('touchmove', preventOverscroll, false);
      }
      document.body.removeEventListener("touchmove", preventBodyScroll, false);
    }
  };
}());

// New version body fix position
let vh;
let widthScrollBar;
let isBodyFixed = false;
let actualInnerWidth;
let headerSearch = null;
let activePopup = null;
const bodyFixPosition = () => {
  setTimeout(() => {
    if (!document.body.hasAttribute("data-body-scroll-fix")) {
      console.log('bodyFix')
      isBodyFixed = true;
      let scrollPos = window.scrollY || document.documentElement.scrollTop;

      document.body.setAttribute("data-body-scroll-fix", scrollPos);
      document.body.classList.add("fixed");
      document.body.style.top = `-${scrollPos}px`;
      document.body.style.overflow = 'hidden';
      document.body.style.left = 0;
      document.body.style.width = `100%`;
      // Коррекция скролла
      if (widthScrollBar > 0)
        document.body.style.paddingRight = `${widthScrollBar}px`;
    }
  }, 18);
};
const bodyUnfixPosition = () => {
  if (document.body.hasAttribute("data-body-scroll-fix")) {
    let scrollPos = document.body.getAttribute("data-body-scroll-fix");
    document.body.removeAttribute("data-body-scroll-fix");
    document.body.classList.remove("fixed");
    document.body.style.top = "";
    document.body.style.paddingRight = "";
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('left');
    document.body.style.removeProperty('width');
    window.scroll(0, scrollPos);
    isBodyFixed = false;
  }
};
const bodyFix = (value) => {
  if (!!value) {
    bodyFixPosition();
  } else {
    bodyUnfixPosition();
  }
};

function findTallestCol(cols) {
  let height = 0;
  cols.each(function () {
    let inner = $(this).find(".comparsion__col__inner");
    if (inner.innerHeight() > height) {
      height = inner.innerHeight();
    }
  })
  return height
}

let sectionTimeout;
let sectionUnitTimeout;

function initBasketTextareaToggle() {
  $(".basket__body__toggle__title").on("click", function () {
    $(this).parents(".basket__body__toggle").addClass("basket__body__toggle--shown");
  })
}
function initDropdowns() {
  $(".dropdown").each(function () {
    var _this = $(this),
      title = _this.find(".dropdown__title"),
      unit = _this.find(".dropdown__unit");
    if ($(this).attr("data-dropdown-body") != false && !$(this).hasClass("dropdown--active")) {
      const id = $(this).attr("data-dropdown-body");
      $(id).slideUp();
    }
    title.on("click", function () {
      _this.toggleClass("dropdown--active");
      if (_this.attr("data-dropdown-body") != false) {
        const id = _this.attr("data-dropdown-body");
        $(id).slideToggle();
      }
    })
    unit.on("click", function () {
      _this.toggleClass("dropdown--active");
      title.find("span").html($(this).html());
    })
  })
  $(document).click(function (event) {
    var elem = $(event.target);
    var closestDropdown = elem.closest(".dropdown");
    $(".dropdown").each(function () {
      if ($(this)[0] != closestDropdown[0]) {
        $(this).removeClass("dropdown--active");
      }
    })
  })
}
function initProfileSectionToggle(){
    $(".profile__section").each(function () {
      var _this = $(this),
        title = _this.find(".profile__section__header"),
        body = _this.find(".profile__section__body"),
        bodyInner = _this.find(".profile__section__body__inner"),
        activeClass = "profile__section--active",
        bodySpeed = 300,
        timeout,
        shouldCollapse = !(_this.parents('.profile').hasClass('profile--vacancy'));

      if(shouldCollapse){
        title.on("click", function () {
          var innerHeight = bodyInner.outerHeight(true);
          _this.toggleClass(activeClass);
          if (_this.hasClass(activeClass)) {
            body.css("max-height", innerHeight + "px");

          } else {
            body.css("max-height", 0 + "px")
          }
        })
      }
    })
  }
function initTabs() {
  const tabs = Array.from(document.querySelectorAll(".tabs"));
  tabs.forEach((tabsEl) => {
    const headerUnitActiveClass = 'tabs__header__unit--active';
    const bodyUnitActiveClass = 'tabs__body__unit--active';
    const header = tabsEl.querySelector(".tabs__header");
    const body = tabsEl.querySelector(".tabs__body");
    const headerUnits = Array.from(header.children);
    const bodyUnits = Array.from(body.children);
    headerUnits.forEach((unit, index) => {
      unit.addEventListener("click", (e) => {
        headerUnits.forEach((unit, index) => {
          unit.classList.remove(headerUnitActiveClass);
          bodyUnits[index].classList.remove(bodyUnitActiveClass);
        });
        unit.classList.add(headerUnitActiveClass);
        let isNamedTab = false;
        if (e.target.closest("[data-tab]")) {
          const targetTabId = e.target.closest("[data-tab]").dataset.tab;
          bodyUnits.forEach((bodyUnit) => {
            if ((bodyUnit.hasAttribute("data-tab") && bodyUnit.dataset.tab === targetTabId) || bodyUnit.querySelector(`[data-tab="${targetTabId}"]`)) {
              bodyUnit.classList.add(bodyUnitActiveClass);
              isNamedTab = true;
            }
          })
        }
        if (!isNamedTab) bodyUnits[index].classList.add(bodyUnitActiveClass);
      });
    });
  });
  //$(".tabs").each(function () {
  //  var _this = $(this),
  //    //bodyUnit = 
  //    bodyUnit = _this.find(".tabs__body").children(".tabs__body__unit"),
  //    headerUnit = _this.find(".tabs__header").children(".tabs__header__unit"),
  //    headerActiveClass = 'tabs__header__unit--active',
  //    bodyActiveClass = 'tabs__body__unit--active';

  //  headerUnit.on('click', function () {
  //    var index = $(this).index();
  //    headerUnit.removeClass(headerActiveClass);
  //    $(this).addClass(headerActiveClass);
  //    bodyUnit.removeClass(bodyActiveClass);
  //    bodyUnit.eq(index).addClass(bodyActiveClass);
  //  })

  //})
}
function initPhoneAdding() {
  $(".form__unit--js-additonal-phone").each(function () {
    const maxInputs = 4;
    var _this = $(this),
      input = _this.find(".form__input").first().clone().val("").attr('value', ''),
      add = _this.find(".form__unit__add");
    add.on("click", function () {
      add.before(input.clone().inputmask("+375 (99) 999 99 99"));
      const inputAmounts = _this.find('input').length;
      if (inputAmounts > maxInputs - 1) {
        _this.addClass('form__unit--js-additonal-phone--max-phones')
      }
    })

  })
}
function initInputmasks() {
  const maskEnd = new Inputmask("999-99-99");
  const maskDefault = new Inputmask("+375 (99) 999 99 99");
  const maskMTS = new Inputmask("+375 (00) 999 99 99");
  //$(".js-number-inputmask").inputmask("999-99-99");
  //$(".js-number-inputmask2").inputmask("+375 (99) 999 99 99");
  maskEnd.mask(document.querySelectorAll(".js-number-inputmask"));
  maskDefault.mask(document.querySelectorAll(".js-number-inputmask2"));
  maskMTS.mask(document.querySelectorAll(".js-number-inputmask-mts"));
}
// FIRM SLIDER VARS START
let pageFirm;
let firmSlider;
let firmSliders = [];
// FIRM SLIDER VARS END

// Cookie Start
let isBlockedCookie = false;
document.addEventListener("cookieClose", () => {
  if (!isBlockedCookie) {
    isBlockedCookie = true;
    isOpenedCookie = false;
    document.querySelector(".cookie").classList.remove("show");
  }
});
window.addEventListener("click", (e) => {
  if (e.target.closest(".cookie__ok") || e.target.closest(".cookie__cancel:not(.back)")) {
    if (!isBlockedCookie) {
      isBlockedCookie = true;
      isOpenedCookie = false;
      document.querySelector(".cookie").classList.remove("show");
    }
  }
  if (e.target.closest(".cookie__close")) {
    isBlockedCookie = true;
    document.querySelector(".cookie").classList.remove("show");
    isOpenedCookie = false;
  }
})
if (document.querySelector(".cookie")) {
  if (!isBlockedCookie) {
    if (document.querySelector(".cookie").classList.contains("show")) {
      //isOpenedCookie = true;
      //bodyFix(true);
      cookieSettings();
    }
  }
}
document.addEventListener("cookieOpen", () => {
  console.log("Cookie Open Handler")
  if (document.querySelector(".cookie")) {
    document.querySelector("body").classList.add("cookie--runned");
    isBlockedCookie = false;
    //isOpenedCookie = true;
    //bodyFix(true);
    const cookie = document.querySelector(".cookie");
    cookie.classList.add("show");
    const handleClickWindow = (e) => {
      const cookieWrap = document.querySelector(".cookie__wrapper");
      if (!e.composedPath().includes(cookieWrap)) {
        isBlockedCookie = true;
        isOpenedCookie = false;
        document.querySelector(".cookie").classList.remove("show");
        window.removeEventListener("click", handleClickWindow);
      }
    }
    cookieSettings();
    window.addEventListener("click", handleClickWindow);
  }
});

// Cookie End

$(document).ready(function () {
  //document.dispatchEvent(new Event("cookieOpen"))

  equalizationHeaderWithBanner();
  window.addEventListener("click", (e) => {
    if (e.target.closest(".header-attention__close")) {
      const attention = document.querySelector(".header-attention");
      const main = document.querySelector(".main");
      main.classList.remove("with-attention");
      attention.classList.add("header-attention__hidden");
      let dateExp = new Date();
      dateExp.setDate(dateExp.getDate() + 3);
      document.cookie = "headerDeliveryBanner=Y; expires=" + dateExp.toUTCString();
    }
  });
  const bodyEl = document.querySelector('body');
  actualInnerWidth = window.innerWidth;
  checkWidthScrollBar();
  checkVH();
  if (document.querySelector(".header-search")) {
    headerSearch =  new HeaderSearch(document.querySelector(".header-search"));
  } else {
    document.addEventListener("initSearch", () => {
      headerSearch =  new HeaderSearch(document.querySelector(".header-search"));
      console.log("Ready Search");
    });
  }
  const mainOnResize = debounce((e) => {
    if (actualInnerWidth !== window.innerWidth) {
      actualInnerWidth = window.innerWidth;
      if (!!headerSearch) headerSearch.close();
      if (!!isBodyFixed) bodyFix(false);
      checkWidthScrollBar();
      if (bodyEl.classList.contains('products-filters--active')) {
        bodyEl.classList.remove('products-filters--active');
      }
      if (window.innerWidth >= 768) {
        $("body,html").removeClass("no-scroll");
        $(".header__burger").removeClass("header__burger--active");
        $(".menu-mobile").removeClass("menu-mobile--active");
        $(".header").removeClass("header--show-mobile-menu");
      }
    }
    checkVH();
  }, 250);
  window.addEventListener("resize", () => {
    mainOnResize();
  });
  if (document.querySelector(".button-pageup")) {
    const buttonPageUp = document.querySelector(".button-pageup");
    if (document.querySelector(".item-shortview")) {
      buttonPageUp.classList.add("button-pageup_dynamic")
    }
    window.addEventListener("scroll", () => {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      scrollY > 400
        ? buttonPageUp.classList.remove("hide")
        : buttonPageUp.classList.add("hide");
    });
    buttonPageUp.addEventListener("click", () => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    });
  }
  initBasketTextareaToggle()
  initDropdowns()
  initTabs()
  initProfileSectionToggle()
  initPhoneAdding()
  initInputmasks()

  if (document.querySelector(".menu-mobile .menu-head")) {
    const wrapperMobileMenu = document.querySelector(".menu-mobile .menu-head");
    const breadcrumbs = document.querySelector(".menu-mobile .menu-bc");
    const allSubmenus = Array.from(wrapperMobileMenu.querySelectorAll(".menu-submenu"));
    const breadcrumbsItems = breadcrumbs.children;
    let lvlMenu = 1;
    breadcrumbs.addEventListener("click", (e) => {
      const target = e.target;
      if (target.closest(".menu-bc__bc.opened")) {
        const targetBc = target.closest(".menu-bc__bc");
        //let targetLvl = 1;
        Array.from(breadcrumbsItems).forEach((bc, ind) => {
          if (bc === targetBc && lvlMenu !== ind + 1) {
            const newLvl = ind + 1;
            const allSubmenus = Array.from(wrapperMobileMenu.querySelectorAll(".menu-submenu.opened"));
            allSubmenus.forEach((submenu, index) => {
              if (index + 1 < newLvl) return;
              const targetBack = submenu.querySelector(".menu-submenu__back");
              const targetSub = targetBack.parentElement.parentElement;
              if (targetSub.classList.contains("opened")) {
                targetSub.classList.remove("opened");
                lvlMenu--;
                const lvlAct = lvlMenu;
                breadcrumbsItems[lvlAct].classList.remove("opened");
                setTimeout(() => {
                  breadcrumbsItems[lvlAct].innerText = '';
                }, 300)
                if (lvlMenu === 1) {
                  breadcrumbs.classList.remove("opened");
                }
              }
            });
          }
        })
      }
    });
    wrapperMobileMenu.addEventListener("click", (e) => {
      const target = e.target;
      if (target.closest(".menu-link")) {
        const targetLink = target.closest(".menu-link");
        if (targetLink.parentElement.querySelector(".menu-submenu")) {
          //e.preventDefault();
          const targetSub = targetLink.parentElement.querySelector(".menu-submenu");
          const nameCategory = targetLink.querySelector(".menu-link__text").innerText;
          if (lvlMenu === 1) {
            breadcrumbs.classList.add("opened");
          }
          breadcrumbsItems[lvlMenu].innerText = nameCategory;
          breadcrumbsItems[lvlMenu].classList.add("opened");
          targetSub.classList.add("opened");
          lvlMenu++;
        }
      }
      if (target.closest(".menu-submenu__back")) {
        const targetBack = target.closest(".menu-submenu__back");
        const targetSub = targetBack.parentElement.parentElement;
        if (targetSub.classList.contains("opened")) {
          targetSub.classList.remove("opened");
          lvlMenu--;
          breadcrumbsItems[lvlMenu].classList.remove("opened");
          setTimeout(() => {
            breadcrumbsItems[lvlMenu].innerText = '';
          }, 300)
          if (lvlMenu === 1) {
            breadcrumbs.classList.remove("opened");
          }
        }
      }
    });
    function backMenu() {

    }
  }
  if (document.querySelector(".header-catalog")) {
    const headerPage = document.querySelector(".header");
    const headerCatalog = document.querySelector(".header-catalog");
    const headerCatalogWrapper = headerCatalog.querySelector(".header-catalog__wrapper");
    const headerCatalogBtn = document.querySelector(".header-catalog__btn");
    const mainItems = Array.from(headerCatalog.querySelectorAll(".menu-list__item"));
    const itemsWithSub = mainItems.filter((item) => !!item.querySelector(".menu-submenu"));
    let activeOpenedItem = itemsWithSub[0];
    activeOpenedItem.classList.add('active');
    const updateOffsetHeight = () => {
      headerCatalog.style.setProperty('--offset-height', headerCatalog.getBoundingClientRect().top + window.pageYOffset + 'px');
    }
    updateOffsetHeight();
    const handleResize = debounce(() => {
      updateOffsetHeight();
    }, 200);
    window.addEventListener("resize", () => {
      handleResize();
    })
    itemsWithSub.forEach((item) => {
      item.addEventListener("mouseenter", () => {
        if (activeOpenedItem !== item) {
          activeOpenedItem.classList.remove("active");
          activeOpenedItem = item;
          activeOpenedItem.classList.add("active");
        }
      });
    });
    function eventClickOnWindow(e) {
      /*if (!e.composedPath().includes(headerCatalogWrapper) && !e.composedPath().includes(headerCatalogBtn)) {
        //headerCatalog.classList.remove("opened");
        //headerCatalogBtn.classList.remove("opened");
        //window.removeEventListener("click", eventClickOnWindow)
      }*/ 
      if (!e.composedPath().includes(headerCatalogBtn) && !e.target.closest(".menu-link") && !e.target.closest(".menu-category__item") && !e.target.closest(".menu-submenu__now")) {
        headerCatalog.classList.remove("opened");
        headerCatalogBtn.classList.remove("opened");
        headerPage.classList.remove("catalog--opened");
        window.removeEventListener("click", eventClickOnWindow)
      }
    }
    headerCatalogBtn.addEventListener("click", () => {
      if (headerCatalog.classList.contains("opened")) {
        headerCatalog.classList.remove("opened");
        headerCatalogBtn.classList.remove("opened");
        headerPage.classList.remove("catalog--opened");
        window.removeEventListener("click", eventClickOnWindow)
      } else {
        headerCatalog.classList.add("opened");
        headerCatalogBtn.classList.add("opened");
        headerPage.classList.add("catalog--opened");
        window.addEventListener("click", eventClickOnWindow)
      }
    });

    const sublists = Array.from(headerCatalog.querySelectorAll(".menu-sublist"));
    sublists.forEach((list) => {
      if (list.children.length > 5) {
        const triggerBtn = document.createElement("button");
        triggerBtn.innerHTML = "<span>Показать еще</span>";
        triggerBtn.classList.add("menu-sublist__more");
        list.after(triggerBtn);
        triggerBtn.addEventListener("click", () => {
          list.classList.toggle("opened");
          triggerBtn.classList.toggle("opened");
          triggerBtn.children[0].innerText = list.classList.contains("opened")
            ? "Свернуть"
            : "Показать еще";
        });
      }
    })
  }

  if (document.querySelector(".christmas-random")) {
    function getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    const randomElements = Array.from(document.querySelectorAll(".christmas-random"));
    randomElements.forEach((el) => {
      el.style.setProperty("--random", getRandomInt(0, 100));
      el.classList.add("ready", "visible");
      function updateVisible() {
        setTimeout(() => {
          el.classList.remove("visible");
          setTimeout(() => {
            el.style.setProperty("--random", getRandomInt(0, 100));
            el.classList.add("visible");
            updateVisible();
          }, 700)
        }, getRandomInt(1500, 3200));
      }
      updateVisible();
    });
    //const k = document.querySelector(".christmas-garland path[stroke]");
    //console.log(k.getTotalLength());
  }


  $(".input-password").each(function () {
    var _this = $(this),
      input = _this.find("input"),
      toggle = _this.find(".input-password__toggle");
    toggle.on("click", function () {
      _this.toggleClass("input-password--shown");
      if (input.attr("type") === "password") {
        input.attr("type", "text");
      } else {
        input.attr("type", "password");
      }
    })
  })
  $(".js-timer").each(function () {
    var timer = $(this);
    var timestamp = $(this).attr("data-time");
    var formattedString = timestamp.substring(6, 10) + "/" + timestamp.substring(3, 5) + "/" + timestamp.substring(0, 2) + " " + timestamp.substring(11);
    var formattedData = new Date(formattedString);
    const second = 1000, minute = second * 60, hour = minute * 60, day = hour * 24;
    var days = $(this).find(".js-timer__days");
    var hours = $(this).find(".js-timer__hours");
    var minutes = $(this).find(".js-timer__minutes");
    let x = setInterval(function () {
      let now = new Date().getTime(),
        distance = formattedData.getTime() - now;
      if (distance > 0) {
        var daysNumber = Math.floor(distance / (day));
        var minutesNumber = Math.floor((distance % (hour)) / (minute));
        var hoursNumber = Math.floor((distance % (day)) / (hour));
        if (days.html() != daysNumber) {
          days.html(daysNumber);
        }
        if (minutes.html() != minutesNumber) {
          minutes.html(minutesNumber);
        }
        if (hours.html() != hoursNumber) {
          hours.html(hoursNumber);
        }

        var vocabulary = {
          days: ['день', 'дня', 'дней'],
          minutes: ['минута', 'минуты', 'минут'],
          hours: ['час', 'часа', 'часов'],
        }
        function editText(number, vocabularyOption) {
          var elemToEdit;
          var convertedToStringNumber = number.toString();

          switch (vocabularyOption) {
            case "days":
              elemToEdit = days;
              break;
            case "minutes":
              elemToEdit = minutes;
              break;
            case "hours":
              elemToEdit = hours;
              break;
          }
          var textElem = elemToEdit.siblings(".js-timer__subtitle");
          var lastSymbol = parseInt(convertedToStringNumber.slice(-1));
          var twoLastSymbols = parseInt(convertedToStringNumber.slice(-2));
          if (twoLastSymbols > 10 && twoLastSymbols < 20) {
            if (textElem.html() != vocabulary[vocabularyOption][2]) {
              textElem.html(vocabulary[vocabularyOption][2]);
            }
          } else if (lastSymbol == 1 && twoLastSymbols != 11) {
            if (textElem.html() != vocabulary[vocabularyOption][0]) {
              textElem.html(vocabulary[vocabularyOption][0]);
            }
          } else if (lastSymbol > 1 && lastSymbol < 5) {
            if (textElem.html() != vocabulary[vocabularyOption][1]) {
              textElem.html(vocabulary[vocabularyOption][1]);
            }
          } else if (lastSymbol > 4 && lastSymbol < 9 || lastSymbol == 0) {
            if (textElem.html() != vocabulary[vocabularyOption][2]) {
              textElem.html(vocabulary[vocabularyOption][2]);
            }
          }
        }

        if (timer.hasClass("js-timer--with-text")) {
          editText(daysNumber, 'days');
          editText(hoursNumber, 'hours');
          editText(minutesNumber, 'minutes');
        }
      }

      if (distance < 0) {
        clearInterval(x);
        days.html('0');
        hours.html('0');
        minutes.html('0');
      }
    }, second)
  })


  $(".js-scrollToReviewsForm").on("click", function () {
    $('html, body').animate({
      scrollTop: $(".item-reviews__form").offset().top - 110
    }, 500);
  })
  $(".item__price__to-cart").on("click", function () {
    $(this).parents(".item__price__controls").addClass("item__price__controls--in-cart");
  })
  $(".item-shortview__button__to-cart").on("click", function () {
    $(this).parents(".item-shortview__controls").addClass("item-shortview__controls--in-cart");
  })
  $(".item__price__promocode__input").on("change paste keyup", function () {
    if ($(this).val().length > 0) {
      $(this).parents(".item__price__promocode").addClass("item__price__promocode--not-empty");
    }
  });
  //$(".item-promocode").each(function () {
  //  var _this = $(this),
  //    icon = _this.find(".item-promocode__icon"),
  //    close = _this.find(".item-promocode__close"),
  //    text = _this.find(".item-promocode__text"),
  //    button = _this.find(".item-promocode__button");
  //  icon.on("click", function () {
  //    _this.addClass("item-promocode--shown");
  //  })
  //  close.on("click", function () {
  //    _this.removeClass("item-promocode--shown");
  //  })
  //  button.on("click", function () {
  //    $(".item__price").addClass("item__price--promocode");
  //  })
  //})
  document.addEventListener("click", (e) => {
    const target = e.target;
    // Promocode
    if (target.closest(".item-promocode")) {
      const promocodeEl = target.closest(".item-promocode");
      if (target.closest(".item-promocode__icon")) {
        promocodeEl.classList.add("item-promocode--shown");
      }
      if (target.closest(".item-promocode__close")) {
        promocodeEl.classList.remove("item-promocode--shown");        
      }
      if (target.closest(".item-promocode__button")) {
        promocodeEl.classList.add("item__price--promocode");
      }
    }
    // NOT REQUIRED
    //if (target.tagName === "INPUT" && target.hasAttribute("data-not-required") && target.checked) {
    //  target.checked = false;
    //}
    if (target.tagName === "LABEL") {
      const targetInputId = target.getAttribute("for");
      const targetInput = document.querySelector(`#${targetInputId}`);
      if (targetInput.hasAttribute("data-not-required") &&!!targetInput.checked) {
        e.preventDefault();
        targetInput.checked = false;
        targetInput.dispatchEvent(new Event("change", {
          bubbles: true
        }));
      }
    }
    // Popup
    if (target.closest(".popup")) {
      const popup = target.closest(".popup");
      if (target.closest(".popup__close")) {
        popup.classList.remove("popup--active");
      }
      if (e.target === popup) {
        popup.classList.remove("popup--active");
      }
      if (target.closest(".popup__body")) {
        e.stopPropagation();
      }
    }
  })
  $(".header__burger").on('click', function () {
    $("body,html").toggleClass("no-scroll");
    $(".header__burger").toggleClass("header__burger--active");
    $(".menu-mobile").toggleClass("menu-mobile--active");
    $(".header").toggleClass("header--show-mobile-menu");
    if ($("body,html").hasClass("no-scroll")) {
      //disableBodyScroll(true, ".menu-mobile");
      bodyFix(true)
    } else {
      //disableBodyScroll(false, ".menu-mobile");
      bodyFix()
    }

  })

  $(".hero").each(function () {
    var _this = $(this),
      heroSlider = _this.find(".hero-slider"),
      previewsSlider = _this.find(".hero-previews__slider");

    var heroPreviewsSliderSwiper = new Swiper(previewsSlider, {
      slidesPerView: "auto",
      loop: false,
      spaceBetween: 5,
      breakpoints: {
        767: {
          spaceBetween: 2,
        }
      }
    })

    var heroSliderSwiper = new Swiper(heroSlider, {
      slidesPerView: 1,
      loop: false,
      effect: "fade",
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      controller: {
        control: heroPreviewsSliderSwiper
      },
      on: {
        init: function () {
          $(".hero-previews__unit").eq(0).addClass("hero-previews__unit--timer");
        },
        slideChange: function () {
          $(".hero-previews__unit").removeClass("hero-previews__unit--timer");
          $(".hero-previews__unit").eq(this.realIndex).addClass("hero-previews__unit--timer");
        },
      }
    })

    $(".hero-previews__unit").on('click', function () {
      heroSliderSwiper.slideTo($(this).index());
    })

  })
  initSelects();

  $(function () {
    $(".details__subtitle").on("click", function(e) {
      e.preventDefault();
      const target = e.target;
      const parent = target.parentElement;
      const body = parent.querySelector(".details__info");
      const list = parent.parentElement;
      if (parent.classList.contains("active")) {
        parent.classList.remove("active");
        $(body).slideUp('slow').removeClass("active");
      } else {
        parent.classList.add("active");
        $(body).slideDown('slow').addClass("active");
      }
      const btnShowAll = list.parentElement.querySelector(".details__showAll");
      if ([...list.children].filter((item) => item.classList.contains("active")).length === list.children.length) {
        if (!!btnShowAll) {
          btnShowAll.innerText = "Свернуть все";
          btnShowAll.classList.add("is-active");
        }
      } else {
        if (!!btnShowAll && btnShowAll.classList.contains("is-active")) {
          btnShowAll.innerText = "Развернуть все";
          btnShowAll.classList.remove("is-active");
        }
      }
    });
    $('.details__showAll').on('click', function(e) {    
      e.preventDefault();
      const target = e.target;
      const items = [...target.parentElement.querySelectorAll(".details__item")];
      const dropdowns = [...target.parentElement.querySelectorAll(".details__info")];
      if (target.classList.contains("is-active")) {
        target.innerText = "Развернуть все";
        target.classList.remove("is-active");
        items.forEach((item) => {
          item.classList.remove("active");
        });
        dropdowns.forEach((dropdown) => {
          $(dropdown).slideUp("slow").removeClass("active");
        });
      } else {
        target.innerText = "Свернуть все";
        target.classList.add("is-active");
        items.forEach((item) => {
          item.classList.add("active");
        });
        dropdowns.forEach((dropdown) => {
          $(dropdown).slideDown("slow").addClass("active");
        });
      }    
    });  
  });
  $(".text-wrap__slider__outer").each(function () {
    var _this = $(this),
      slider = _this.find(".text-wrap__slider"),
      prevArrow = _this.find(".text-wrap__slider__controls__prev"),
      nextArrow = _this.find(".text-wrap__slider__controls__next");
    var params = {
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      slidesPerView: 1,
      navigation: {
        nextEl: nextArrow,
        prevEl: prevArrow,
      },

    };
    var sliderEntity = new Swiper(slider, params);
  })
  $(".promotions-slider__outer").each(function () {
    var _this = $(this),
      slider = _this.find(".promotions-slider"),
      prevArrow = _this.find(".promotions-slider__controls__prev"),
      nextArrow = _this.find(".promotions-slider__controls__next");
    var params = {
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      slidesPerView: 1,
      navigation: {
        nextEl: nextArrow,
        prevEl: prevArrow,
      },

    };
    var sliderEntity = new Swiper(slider, params);
  })

  initProductSlider();
  $(".special-offers__outer").each(function () {
    var _this = $(this),
      slider = _this.find(".special-offers"),
      prevArrow = _this.find(".special-offers__controls__prev"),
      nextArrow = _this.find(".special-offers__controls__next");

    var params = {
      loop: false,
      slidesPerView: 3,
      spaceBetween: 30,
      navigation: {
        nextEl: nextArrow,
        prevEl: prevArrow,
      },
      breakpoints: {
        767: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        1200: {
          slidesPerView: 2,
          spaceBetween: 12,
        }
      }
    };
    var sliderEntity = new Swiper(slider, params);

  })

  $(".products-reviews__outer").each(function () {
    var _this = $(this),
      slider = _this.find(".products-reviews"),
      prevArrow = _this.find(".products-reviews__controls__prev"),
      nextArrow = _this.find(".products-reviews__controls__next");
    var params = {
      loop: false,
      slidesPerView: 2,
      spaceBetween: 30,
      navigation: {
        nextEl: nextArrow,
        prevEl: prevArrow,
      },
      breakpoints: {
        1200: {
          slidesPerView: 1,
          spaceBetween: 40,
        }
      }
    };
    var sliderEntity = new Swiper(slider, params);

  })
  $(".products-filters__section:not(.products-filters__section--no-wrap)").each(function () {
    var section = $(this),
      header = section.find(".products-filters__section__header"),
      body = section.find(".products-filters__section__body"),
      bodyInner = section.find(".products-filters__section__body__inner"),
      close = section.find(".products-filters__section__close"),
      activeClass = "products-filters__section--active";
    header.on("click", function () {
      section.toggleClass(activeClass);
      if (section.hasClass(activeClass)) {
        var innerHeight = bodyInner.outerHeight(true);
        body.css("max-height", innerHeight + "px");
      } else {
        body.css("max-height", 0 + "px");
      }
    })

  })
  $(".accordeon__unit").each(function () {
    var unit = $(this),
      header = unit.find(".accordeon__unit__header"),
      body = unit.find(".accordeon__unit__body"),
      bodyInner = unit.find(".accordeon__unit__body__inner"),
      activeClass = "accordeon__unit--active";

    header.on("click", function () {
      unit.toggleClass(activeClass);
      if (unit.hasClass(activeClass)) {
        var innerHeight = bodyInner.outerHeight(true);
        body.css("max-height", innerHeight + "px");
      } else {
        body.css("max-height", 0 + "px");
      }
    })
  })
  if (document.querySelector("[data-timer]")) {
    const timerTimers = setInterval(updateTimers, 1000);
    function updateTimers() {
      const timers = Array.from(document.querySelectorAll("[data-timer]"));
      timers.forEach((timerWrapper) => countdownTimer(timerWrapper));
      if (timers.length <= 0) {
        clearInterval(timerTimers)
      }
    }
    function declensionNum(num, words) {
      return words[(num % 100 > 4 && num % 100 < 20) ? 2 : [2, 0, 1, 1, 1, 2][(num % 10 < 5) ? num % 10 : 5]];
    }
    function countdownTimer(timerWrapper) {
      const $days = timerWrapper.querySelector('.timer__days');
      const $hours = timerWrapper.querySelector('.timer__hours');
      const $minutes = timerWrapper.querySelector('.timer__minutes');
      const $seconds = timerWrapper.querySelector('.timer__seconds');
      const diff = new Date(timerWrapper.dataset.timer) - new Date();
      if (diff <= 0) {
        timerWrapper.removeAttribute("data-timer");
      }
      const days = diff > 0 ? Math.floor(diff / 1000 / 60 / 60 / 24) : 0;
      const hours = diff > 0 ? Math.floor(diff / 1000 / 60 / 60) % 24 : 0;
      const minutes = diff > 0 ? Math.floor(diff / 1000 / 60) % 60 : 0;
      const seconds = diff > 0 ? Math.floor(diff / 1000) % 60 : 0;
      $days.textContent = days < 10 ? '0' + days : days;
      $hours.textContent = hours < 10 ? '0' + hours : hours;
      $minutes.textContent = minutes < 10 ? '0' + minutes : minutes;
      $seconds.textContent = seconds < 10 ? '0' + seconds : seconds;
      $days.dataset.title = declensionNum(days, ['день', 'дня', 'дней']);
      $hours.dataset.title = declensionNum(hours, ['час', 'часа', 'часов']);
      $minutes.dataset.title = declensionNum(minutes, ['минута', 'минуты', 'минут']);
      $seconds.dataset.title = declensionNum(seconds, ['секунда', 'секунды', 'секунд']);
    }
    //timers.forEach((timerWrapper) => {
    //  const deadline = new Date(timerWrapper.dataset.timer);
    //  let timerId = null;
    //  function declensionNum(num, words) {
    //    return words[(num % 100 > 4 && num % 100 < 20) ? 2 : [2, 0, 1, 1, 1, 2][(num % 10 < 5) ? num % 10 : 5]];
    //  }
    //  function countdownTimer() {
    //    const diff = deadline - new Date();
    //    if (diff <= 0) {
    //      clearInterval(timerId);
    //    }
    //    const days = diff > 0 ? Math.floor(diff / 1000 / 60 / 60 / 24) : 0;
    //    const hours = diff > 0 ? Math.floor(diff / 1000 / 60 / 60) % 24 : 0;
    //    const minutes = diff > 0 ? Math.floor(diff / 1000 / 60) % 60 : 0;
    //    const seconds = diff > 0 ? Math.floor(diff / 1000) % 60 : 0;
    //    $days.textContent = days < 10 ? '0' + days : days;
    //    $hours.textContent = hours < 10 ? '0' + hours : hours;
    //    $minutes.textContent = minutes < 10 ? '0' + minutes : minutes;
    //    $seconds.textContent = seconds < 10 ? '0' + seconds : seconds;
    //    $days.dataset.title = declensionNum(days, ['день', 'дня', 'дней']);
    //    $hours.dataset.title = declensionNum(hours, ['час', 'часа', 'часов']);
    //    $minutes.dataset.title = declensionNum(minutes, ['минута', 'минуты', 'минут']);
    //    $seconds.dataset.title = declensionNum(seconds, ['секунда', 'секунды', 'секунд']);
    //  }
    //  const $days = timerWrapper.querySelector('.timer__days');
    //  const $hours = timerWrapper.querySelector('.timer__hours');
    //  const $minutes = timerWrapper.querySelector('.timer__minutes');
    //  const $seconds = timerWrapper.querySelector('.timer__seconds');
    //  countdownTimer();
    //  timerId = setInterval(countdownTimer, 1000);
    //});
  }
  if (document.querySelector(".slider--action")) {
    const sliderWrapper = document.querySelector(".slider--action");
    const sliderAction = sliderWrapper.querySelector(".swiper");
    const prevBtn = sliderWrapper.querySelector(".swiper-button-prev");
    const nextBtn = sliderWrapper.querySelector(".swiper-button-next");
    const swiper = new Swiper(sliderAction, {
      loop: true,
      spaceBetween: 30,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return `<div class="${className}"></div>`;
        },
      },
    })
  }
  // Product Card Slider
  initCardsProduct();
  
  
  //$(".item-specialOffers__unit").each(function () {
  //  var section = $(this),
  //    header = section.find(".item-specialOffers__unit__header"),
  //    body = section.find(".item-specialOffers__unit__body"),
  //    bodyInner = section.find(".item-specialOffers__unit__body__inner"),
  //    close = section.find("icon item-specialOffers__unit__header__icon"),
  //    activeClass = "item-specialOffers__unit--active",
  //    tab = section.find('.tab'),
  //    tabInput = tab.find('input');
  //  tabInput.on('change', () => {
  //    var innerHeight = bodyInner.outerHeight(true);
  //    body.css("max-height", innerHeight + "px");
  //  })
  //  //if (section.index() == 0) {
  //  //  section.toggleClass(activeClass);
  //  //  var innerHeight = bodyInner.outerHeight(true);
  //  //  body.css("max-height", innerHeight + "px");
  //  //}
  //  header.on("click", function () {
  //    section.toggleClass(activeClass);
  //    if (section.hasClass(activeClass)) {
  //      var innerHeight = bodyInner.outerHeight(true);
  //      body.css("max-height", innerHeight + "px");
  //    } else {
  //      body.css("max-height", 0 + "px");
  //    }
  //  })

  //})
  $(".products-filters__section__more").on("click", function () {
    var body = $(this).parents(".products-filters__section__body"),
      bodyInner = body.find('.products-filters__section__body__inner');
    body.addClass('products-filters__section__body--expanded');
    var innerHeight = bodyInner.outerHeight(true);
    body.css("max-height", innerHeight + "px");
  })

  var transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend';
  var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';

  $('.js-addToCart').on('click', function () {
    $('.js-addToCart').addClass("js-addToCart--disabled");
    var slideSpeed = 300;
    var cart = $('.header__cart'), topOffset, leftOffset, cartCopy, cartToAim;
    var popupCart = $('.header__cart').clone().addClass("header__cart--js-fixed");
    var isMobile = window.innerWidth < 767;
    $(this).toggleClass("js-addToCart--added");
    function slideNewNumber(cart, increment) {
      var innerLast = cart.find(".header__cart__button__inner").last();
      var number = parseInt(innerLast.find(".header__cart__amount").html());

      var newInner = innerLast.clone();
      var newNumber;
      if (increment) {
        newNumber = number + 1;
        newInner.find(".header__cart__amount").html(newNumber);
        innerLast.after(newInner);
      } else {
        newNumber = number - 1;
      }
      var inner = cart.find(".header__cart__button__inner");
      setTimeout(function () {
        inner.each(function () {
          $(this).css("transform", "translateX(" + parseInt(-100 * newNumber) + "%)");
        })
      }, 1);
      if (!increment) {
        setTimeout(function () {
          cart.find(".header__cart__button__inner").last().remove();
        }, slideSpeed)
      }

    }
    if ($(this).hasClass("js-addToCart--added")) {

      if (isMobile) {
        cartToAim = cart;
        topOffset = 10;
        leftOffset = cartToAim.innerWidth() - 20;
      } else {
        cartToAim = popupCart;
        topOffset = 27;
        leftOffset = cartToAim.innerWidth();
        $('body').append(cartToAim);
      }
      var imgtodrag = $(this).parents('.products__unit').find('.products__unit__image').eq(0);
      if (imgtodrag) {
        var imgclone = imgtodrag.clone()
          .css({
            top: imgtodrag.offset().top,
            left: imgtodrag.offset().left
          })
          .appendTo($('body')).addClass("move-to-cart");
        if (isMobile) {
          cartToAim.addClass("header__cart--js-fixed--shown");
        }



        setTimeout(function () {
          imgclone.addClass("animate");
          imgclone.css({ "top": cartToAim.offset().top + topOffset });
          imgclone.css({ "left": cartToAim.offset().left - leftOffset });
          cartToAim.addClass('header__cart--js-fixed--shown');

          imgclone.one(transitionEnd, function (event) {
            if (!isMobile) {
              slideNewNumber(popupCart, true);
            }
            slideNewNumber(cart, true);
            imgclone.off(transitionEnd);
            $(this).addClass("hide-img");
            setTimeout(function () {
              imgclone.one(transitionEnd, function (event) {
                imgclone.off(transitionEnd);
                $(this).detach();
                $('.js-addToCart').removeClass("js-addToCart--disabled");
                if (!isMobile) {
                  cartToAim.removeClass('header__cart--js-fixed--shown');
                  setTimeout(function () {
                    cartToAim.remove()
                  }, slideSpeed);
                }
              });
            }, 1);
          });
        }, 1);

      }
    } else {
      slideNewNumber(cart, false);
      setTimeout(function () {
        $('.js-addToCart').removeClass("js-addToCart--disabled");
      }, slideSpeed)
    }
  });
  
  // Filter popup open/close functional
  document.addEventListener('click', (e) => {
    const target = e.target;
    if (target.closest('.header__filters')) {
      bodyEl.classList.add("products-filters--active");
      bodyFix(true);
    }
    if (bodyEl.classList.contains("products-filters--active") &&
      (target.classList.contains("products-filters__close") ||
      target.classList.contains("products-filters") ||
      target.classList.contains("products-filters__result__title") ||
      target.closest(".filter-button__state_clear"))
    ) {
      bodyEl.classList.remove("products-filters--active");
      bodyFix(false);
    }
  });
  

  $(".js-show-preorder-popup").on("click", function () {
    $(".preorder-popup").addClass("popup--active");
  })



  $(".accessories__outer").each(function () {
    var _this = $(this),
      slider = _this.find(".accessories"),
      prevArrow = _this.find(".accessories__controls__prev"),
      nextArrow = _this.find(".accessories__controls__next"),
      sliderEntity,
      breakpoint = 768;
    var params = {
      loop: false,
      slidesPerView: 4,
      spaceBetween: 30,
      navigation: {
        nextEl: nextArrow,
        prevEl: prevArrow,
      },
      breakpoints: {
        1200: {
          slidesPerView: 3,
          spaceBetween: 12,
        },
        767: {
          slidesPerView: "auto",
          spaceBetween: 10,
        }
      }
    };
    var sliderEntity = new Swiper(slider, params);

  })
  $(".accessories__unit__controls__button--add").on("click", function () {
    $(this).parents(".accessories__unit").addClass("accessories__unit--added");
  })
  $(".section--special .section__header").on("click", function () {
    $(this).parents(".section").toggleClass("section--special--open");
  })
  $(".item__gallery").each(function () {
    var _this = $(this),
      previewUnit = _this.find(".item__gallery__preview__unit"),
      slider = _this.find(".item__gallery__body"),
      sliderOuter = _this.find(".item__gallery__body__outer"),
      nextArrow = _this.find(".item__gallery__controls__next"),
      prevArrow = _this.find(".item__gallery__controls__prev"),
      closeButton = _this.find(".item__gallery__close"),
      progress = _this.find(".item__gallery__progress"),
      slidesAmount = $(".item__gallery__unit").length,
      previewImageSource = $(".item__image>img").attr("src");

    $(this).attr('data-preview', previewImageSource);

    var previewImage = $(this).attr("data-preview");
    var params = {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: nextArrow,
        prevEl: prevArrow,
      },
      pagination: {
        el: progress,
        type: 'progressbar',
      },
      on: {
        init: function () {
          $(".hero-previews__unit").eq(0).addClass("hero-previews__unit--timer");
        },
        slideChange: function () {
          if (this.slides[this.previousIndex].querySelector(".preview-video")) {
            const previousVideo = this.slides[this.previousIndex].querySelector(".preview-video");
            previousVideo.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
          }
          $(".youtube-wrap").removeClass("youtube-wrap--clickable");
          //$(".preview-video")[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
          previewUnit.removeClass("item__gallery__preview__unit--active");
          previewUnit.eq(this.realIndex).addClass("item__gallery__preview__unit--active");
        },
      }
    };
    $(".youtube-wrap__cover").on("click", function () {
      $(this).parents(".youtube-wrap").addClass("youtube-wrap--clickable");
      $(this).parents(".youtube-wrap").find(".preview-video")[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
    })
    let gallerySlider = null;
    if (document.querySelector(".popup-gallery")) {
      const popupGallery = document.querySelector(".popup-gallery");
      const paginationEl = popupGallery.querySelector(".swiper-pagination");
      const closeBtn = popupGallery.querySelector("[data-close]");
      const swiperElem = popupGallery.querySelector(".swiper");
      const prevBtn = popupGallery.querySelector(".swiper-button-prev");
      const nextBtn = popupGallery.querySelector(".swiper-button-next");
      gallerySlider = new Swiper(swiperElem, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
        on: {
          slideChange: function () {
            players.forEach((player) => {
                player.player.stopVideo();
            });
          },
        },
        pagination: {
          el: paginationEl,
          clickable: true,
          renderBullet: function (index, className) {
            return `<div class="${className}"></div>`;
          },
        },
      });
      closeBtn.addEventListener("click", (e) => {
        players.forEach((player) => {
          player.player.stopVideo();
        });
      })
    }
    var sliderEntity = new Swiper(slider, params);
    if (gallerySlider) {
      sliderEntity.controller.control = gallerySlider;
      gallerySlider.controller.control = sliderEntity;
    }

    closeButton.on("click", function () {
      //if ($(".preview-video").length > 0) {
      //  $(".preview-video")[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
      //}
      if (sliderEntity.wrapperEl.querySelector(".preview-video")) {
        players.forEach((player) => {
          player.player.stopVideo();
        });
        const allVideos = Array.from(sliderEntity.wrapperEl.querySelectorAll(".preview-video"));
        allVideos.forEach((video) => {
          video.contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
        });
      }
      sliderOuter.removeClass("item__gallery__body__outer--shown");
      previewUnit.removeClass("item__gallery__preview__unit--active");
    })
    previewUnit.on("click", function () {
      $('html, body').animate({
        scrollTop: $(this).offset().top - 110
      }, 500);
      sliderOuter.addClass("item__gallery__body__outer--shown");
      sliderEntity.slideTo($(this).index());
    })
    $(window).on("resize", function () {
      controlFirstSlide();
    });
    controlFirstSlide();
    function controlFirstSlide() {
      var width = window.innerWidth;
      if (width < 1201) {
        if (!$(".item__gallery__unit").eq(0).hasClass("item__gallery__unit--preview")) {
          sliderEntity.prependSlide('<div class="item__gallery__unit item__gallery__unit--preview swiper-slide""><img src="' + previewImage + '" alt=""></div>');
          if (gallerySlider) {
            gallerySlider.prependSlide('<div class="swiper-slide""><img src="' + previewImage + '" alt=""></div>');
          }
          sliderEntity.slideTo(0);
          if (gallerySlider) {
            gallerySlider.slideTo(0);
          }
          if (sliderEntity.realIndex == 1) {
          }
        }
      } else {
        if ($(".item__gallery__unit").eq(0).hasClass("item__gallery__unit--preview")) {
          sliderEntity.removeSlide(0);
          if (gallerySlider) {
            gallerySlider.removeSlide(0);
          }
        }
      }
    }
  })


  $(".item-shortview__mobile-controls__button--controls").on("click", function () {
    $(this).parents(".item-shortview").toggleClass("item-shortview--expanded");
    $(".button-pageup").toggleClass("button-pageup_right");
  })
  $(".item-specs__unit").each(function () {
    var _this = $(this),
      title = _this.find(".item-specs__unit__title"),
      body = _this.find(".item-specs__unit__body"),
      bodyInner = _this.find(".item-specs__unit__body__inner"),
      activeClass = "item-specs__unit--active",
      bodySpeed = 300,
      timeout;
    function toggleOn(body) {
      var innerHeight = bodyInner.outerHeight(true);
      body.css("max-height", innerHeight + "px");
      timeout = setTimeout(function () {
        body.css("overflow", 'visible');
      }, bodySpeed)
    }
    function toggleOff(body) {
      body.css("max-height", 0 + "px")
      body.css("overflow", 'hidden');
    }
    title.on("click", function () {
      _this.toggleClass(activeClass);
      if (_this.hasClass(activeClass)) {
        toggleOn(body);

      } else {
        toggleOff(body);
      }
    })
    if (window.innerWidth > 1200) {
      if ($(this).index() == 0) {

        _this.toggleClass(activeClass);
        if (_this.hasClass(activeClass)) {
          toggleOn(body);
        } else {
          toggleOff(body);
        }
      }
    }
  })
  $(".menu-mobile__nav .nav__unit:not(.nav__unit--sale) .nav__unit__title").on('click', function () {
    var _this = $(this),
      navUnit = _this.parents(".nav__unit"),
      body = navUnit.find(".nav__unit__body"),
      bodyInner = body.find(".nav__unit__body__inner"),
      activeClass = "nav__unit--active";
    innerHeight = bodyInner.height();

    navUnit.siblings(".nav__unit").removeClass(activeClass);
    navUnit.siblings(".nav__unit").find(".nav__unit__body").animate({ height: 0 }, 300);
    if (navUnit.hasClass(activeClass)) {
      navUnit.removeClass(activeClass);
      body.animate({ height: 0 }, 300);
    } else {
      navUnit.addClass(activeClass);
      body.animate({ height: bodyInner.height() }, 300);
    }

  })

  $(".form__number__code__header").on("click", function () {
    $(this).parents(".form__number__code").toggleClass("form__number__code--active");
  })
  $(".form__number__code__subunit").on("click", function () {
    var codeParent = $(this).parents(".form__number__code"),
      value = $(this).html();
    codeParent.removeClass("form__number__code--active");
    codeParent.find("input").val(value);
    codeParent.find(".form__number__code__title").html(value);

  })
  //$(".popup__close").on("click", function () {
  //  $(this).parents(".popup").removeClass("popup--active");

  //})
  //$(".popup").on("click", function () {
  //  $(this).removeClass("popup--active");
  //})
  //$(".popup__body").on("click", function (e) {
  //  e.stopPropagation();
  //})
  $(".js-products__unit__likes").on("click", function (e) {
    $(this).toggleClass("products__unit__likes--active");
  })
  $(".btn-round--with-states").on("click", function (e) {
    $(this).addClass("btn-round--selected");
    $(this).siblings(".products__unit__controls__big-button").find(".btn-round--with-states").removeClass("btn-round--selected");
    if ($(this).hasClass("products__unit__controls__btn")) {
      $(this).parents(".products__unit__controls").addClass("products__unit__controls--shown");
    }
  })

  $(".js-item__controls__unit").click(function () {
    $(this).toggleClass("item__controls__unit--active");
  })
  $(".products__unit__controls__big-button").click(function () {
    $(this).find(".btn-round--with-states").toggleClass("btn-round--selected");
    $(this).siblings(".btn-round--with-states").toggleClass("btn-round--selected");

  })


  $(".item__all-chars").on("click", function () {
    $('html, body').animate({
      scrollTop: $('.item-specs').offset().top - 110
    }, 500);
  })
  $(".products-filters__expand__link").on("click", function () {
    $(this).parents(".products-filters__body").addClass("products-filters__body--expanded");
  })
  $(".products-list__sort__type").on("click", function () {
    $(this).parents(".products-list__sort").toggleClass("products-list__sort--shown");
  })
  $(".products-list__sort__body__unit").on("click", function () {
    $(this).parents(".products-list__sort__type").find("span").html($(this).html());
  })
  $(".item__price__notification__icon").on("click", function () {
    $(this).parents(".item__price__notification").addClass("item__price__notification--active");
  })
  $(".item__price__notification__close").on("click", function () {
    $(this).parents(".item__price__notification").removeClass("item__price__notification--active");
  })


  
  
  $(".profile:not(.profile--vacancy)").each(function () {
    $(document).on("scroll", onScroll);

    function onScroll(event) {
      var scrollPos = $(document).scrollTop();
      $('.profile__sidebar__unit').each(function () {
        var currLink = $(this).find('.profile__sidebar__unit__link'),
          refElement = $(currLink.attr("data-id"));
        if (refElement.position().top - 120 <= scrollPos && refElement.position().top + refElement.height() * 2 / 3 > scrollPos) {
          $('.profile__sidebar__unit').removeClass("profile__sidebar__unit--active");
          $(this).addClass("profile__sidebar__unit--active");
        }
      });
    }
    $(".profile__sidebar__unit__link").on("click", function () {
      var id = $(this).attr("data-id");
      $("html, body").animate({
        scrollTop: $(id).offset().top
      }, 1000);
    })
  })
  
  initComparsionPage();

  addMainSliderBgImage();
  initMainSlider();
  initAltAccordeons();
  wrapTextTables();
  function initSurvey() {
    $('.survey').each(function() {
      const survey = $(this),
        progress = survey.find('.survey-progress'),
        progressLine = progress.find('.survey-progress__line--progress'),
        progressDots = progress.find('.survey-progress__unit'),
        progressDotsActiveClass = 'survey-progress__unit--current',
        progressDotsCompleteClass = 'survey-progress__unit--complete',
        surveyMultipleClass = 'survey--multiple',
        surveyNotLastClass = 'survey--not-last',
        surveylastStepClass = 'survey--last'
        surveyMultipleActiveClass = 'survey--multiple-active',
        surveyCompleteClass = 'survey--complete',
        steps = survey.find('.survey__unit'),
        stepsActiveClass = 'survey__unit--active',
        stepsMultipleClass = 'survey__unit--multiple',
        stepsAmount = steps.length,
        backButton = survey.find('.survey__back'),
        nextButton = survey.find('.survey__next'),
        submitButton = survey.find('.survey__submit');
      function updateProgressLine(newStep) {
        const width = (newStep/(stepsAmount - 1))*100;
        progressLine.css('width',`calc(${width}% - 12px)`);
        progressDots.each((index)=>{
          progressDots.eq(index).removeClass(`${progressDotsActiveClass} ${progressDotsCompleteClass}`);
          if(index<newStep){
            progressDots.eq(index).addClass(progressDotsCompleteClass);
          } else if (index==newStep ){
            progressDots.eq(index).addClass(progressDotsActiveClass);
          }
        })
      }
      function manageMultipleChoice(stepElement){
        const checkboxes = stepElement.find('.survey-rating__unit--checkbox input');
        checkboxes.click(()=>{
          if(stepElement.find('.survey-rating__unit--checkbox input:checked').length > 0){
            survey.addClass(surveyMultipleActiveClass);
          } else {
            survey.removeClass(surveyMultipleActiveClass);
          }
        })
      }
      function updateSurvey(newStep) {
        updateProgressLine(newStep);
        survey.removeClass(`${surveyNotLastClass} ${surveyMultipleClass} ${surveylastStepClass}`);
        survey.attr('data-step',newStep);
        steps.removeClass(stepsActiveClass);
        const newStepElem = steps.eq(newStep),
          multipleChoice = newStepElem.hasClass(stepsMultipleClass),
          lastStep = newStep === stepsAmount - 1;
        newStepElem.addClass(stepsActiveClass);
        if(newStep!=0){
          survey.addClass(surveyNotLastClass);
        }
        if (multipleChoice){
          survey.addClass(surveyMultipleClass);
          manageMultipleChoice(newStepElem);
          
        }
        if (lastStep){
          survey.addClass(surveylastStepClass);
        }
      }
      function updateStep(back=false) {
        const currentStep = survey.attr('data-step'),
          newStepNumber = parseInt(currentStep) + (back ? -1 : 1);
        if((!back && newStepNumber < stepsAmount ) || (back && newStepNumber >= 0)) {
          updateSurvey(newStepNumber);
        }
      }
      submitButton.click((e)=>{
        e.preventDefault();
        survey.addClass(surveyCompleteClass);
      })
      backButton.click(()=>{
        updateStep(true);
      })
      nextButton.click(()=>{
        updateStep();
      })
      steps.each(function() {
        const ratingButton = $(this).find('.survey-rating__unit:not(.survey-rating__unit--checkbox) input');
        ratingButton.click(() =>{
          updateStep();
        })
      })
    })
  }
  initSurvey();

  if(document.querySelector(".tariffs__search")) {
    document.querySelector(".tariffs__search").addEventListener("click", function(e) {
      if(e.target.classList.contains("tariffs__btn--open")) {
        this.classList.add("active");
        this.querySelector("input").select();
      }
      if(e.target.classList.contains("tariffs__btn--close")) {
        this.classList.remove("active");
        this.querySelector("input").value = '';
      }
    })
  }

  if (document.querySelector(".chinany-sakura")) {
    $('body').sakura();
  }

  
  if(document.querySelector(".panel-cookie")) {
    document.querySelector(".panel-cookie").addEventListener("click", function(e) {
        if(e.target.classList.contains("panel-cookie__btn")) {
            const panel = e.target.closest(".bottom-fix-panel");
            panel.style.transform = "translateY(100%)"
            setTimeout(() => {
                panel.style.display = "none"
            }, 200)
        }
    })
  }
  if(document.querySelector(".plan-slider")) {
    $(".plan-slider").slick({
        variableWidth: true,
        arrows: false,
        swipeToSlide: true,
        infinite: true
    })
        
  }
  if(document.querySelector(".plan-tabs")) {
    document.querySelector(".plan-tabs").addEventListener("click", function(e) {
        if(e.target.classList.contains("plan-tabs__btn")) {
            const data = e.target.dataset.tab
            document.querySelector(".plan-tabs__btn.active").classList.remove("active")
            document.querySelector(".plan-tabs__content.active").classList.remove("active")

            e.target.classList.add("active")
            document.querySelector(`.plan-tabs__content[data-tab="${data}"]`).classList.add("active")

        }
    })
  }
  // SELECTS DEFAULT >>>
  if (document.querySelector(".select-default")) {
    const selects = Array.from(document.querySelectorAll(".select-default"));
    selects.forEach((selectEl) => {
      const select = selectEl.querySelector("select");
      select.addEventListener("click", (e) => {
        if (selectEl.classList.contains("opened")) {
          selectEl.classList.remove("opened");
        } else selectEl.classList.add("opened");
      });
      select.addEventListener("blur", (e) => {
        if (selectEl.classList.contains("opened")) selectEl.classList.remove("opened");
      });
    });
  }
  // SELECTS DEFAULT <<<
  // FIRM SLIDERS START
  const funcOnResize = debounce((e) => {
    updateFirmPopularSlider();
  }, 250);
  const runReviewsSlider = () => {
    if (document.querySelector(".reviews__slider")) {
      $(".reviews__slider").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow:
          '<button class="slider__arrow slider__arrow--prev"></button>',
        nextArrow:
          '<button class="slider__arrow slider__arrow--next"></button>',
        responsive: [
          {
            breakpoint: 1000,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    }
  };
  if (
    document.querySelector(".apple") ||
    document.querySelector(".samsung") ||
    document.querySelector(".honor-page")
  ) {
    if (document.querySelector(".slider__list")) {
      updateFirmPopularSlider();
      window.addEventListener("resize", () => {
        funcOnResize();
      });
    }
    runReviewsSlider();
  }
  if (document.querySelector(".xiaomi") || document.querySelector(".huawei")) {
    if (document.querySelector(".popular__slider") || document.querySelector(".popular__list")) {
      updateFirmPopularSlider();
      window.addEventListener("resize", () => {
        funcOnResize();
      });
    }
    runReviewsSlider();
  }
  if (document.querySelector(".tcl-page") || document.querySelector(".yandex-page") || document.querySelector(".birth-page") || document.querySelector(".february-page") || document.querySelector(".women-page")) {
    if (document.querySelector(".birth__timer")) return;
    updateFirmPopularSlider();
    runReviewsSlider();
  }
  // FIRM SLIDERS END
  if(document.querySelector("video.lazy")) {
    var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
    if ("IntersectionObserver" in window) {
      var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(video) {
          if (video.isIntersecting) {
            for (var source in video.target.children) {
              var videoSource = video.target.children[source];
              if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                videoSource.src = videoSource.dataset.src;
              }
            }
            
            video.target.load();
            video.target.classList.remove("lazy");
            lazyVideoObserver.unobserve(video.target);
          }
        });
      });
  
      lazyVideos.forEach(function(lazyVideo) {
        lazyVideoObserver.observe(lazyVideo);
      });
    }
  }
  // Promo Template Scripts
  if (document.querySelector('.promo')) {
    const promoPage = document.querySelector(".promo");
    // Popular Section - Slider
    if (document.querySelector(".popular__slider")) {
      const newSlider = promoPage.querySelector(".popular__slider");
      const sliderPrevBtn = newSlider.querySelector(
        ".product-slider__controls__prev"
      );
      const sliderNextBtn = newSlider.querySelector(
        ".product-slider__controls__next"
      );
      const popularSliderSettings = {
        loop: false,
        slidesPerView: 4,
        spaceBetween: 30,
        navigation: {
          nextEl: sliderNextBtn,
          prevEl: sliderPrevBtn,
        },
        breakpoints: {
          500: {
            slidesPerView: 1,
            spaceBetween: 25,
          },
          767: {
            slidesPerView: 2,
            spaceBetween: 0,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 12,
          },
        },
      };
      const sliderPopular = new Swiper(newSlider, popularSliderSettings);
    }
    // Profit Section - Slider
    if (promoPage.querySelector(".profit__slider")) {
      const parentSlider = promoPage.querySelector(".profit__slider");
      const newSlider = parentSlider.querySelector(".swiper-container");
      //const sliderPrevBtn = profitSlider.querySelector('.slider__btn_prev');
      //const sliderNextBtn = profitSlider.querySelector('.slider__btn_next');
      const sliderPrevBtn = parentSlider.querySelector(
        ".product-slider__controls__prev"
      );
      const sliderNextBtn = parentSlider.querySelector(
        ".product-slider__controls__next"
      );
      const profitSliderSettings = {
        slidesPerView: 3,
        sliderPerScroll: 1,
        spaceBetween: 30,
        navigation: {
          nextEl: sliderNextBtn,
          prevEl: sliderPrevBtn,
        },
        breakpoints: {
          500: {
            slidesPerView: 1,
            spaceBetween: 25,
          },
          900: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
        },
      };
      const sliderProfit = new Swiper(newSlider, profitSliderSettings);
    }
    // TODO: Remove after promo >>>
    if (document.querySelector(".halloween") || document.querySelector(".black-sale")) {
      const categoryItems = Array.from(document.querySelectorAll(".preview__item"));
      categoryItems.forEach((item) => {
        $(item).waypoint({
          handler: function (direction) {
            categoryItems.forEach((el) =>
              el.classList.remove("preview__item_visible")
            );
            if (direction === "down") {
              categoryItems.forEach((el) =>
                el.classList.remove("preview__item_visible")
              );
              if (!item.classList.contains('preview__item_visible')) item.classList.add("preview__item_visible");
            } else if (direction === "up") {
              categoryItems.forEach((el) =>
                el.classList.remove("preview__item_visible")
              );
              if (!item.classList.contains('preview__item_visible')) item.classList.add("preview__item_visible");
            }
          },
          offset: "30%",
        });
      });

      if (document.querySelector(".black-sale") && document.querySelector(".preview__more")) {
        const previewMoreBtn = document.querySelector(".preview__more");
        const previewBg = document.querySelector(".preview__bg");
        previewBg.classList.add("preview__bg_load")
        previewMoreBtn.addEventListener('mouseover', () => {
          if (!previewBg.classList.contains('preview__bg_visible')) previewBg.classList.add("preview__bg_visible");
        });
        previewMoreBtn.addEventListener('mouseleave', () => {
          if (previewBg.classList.contains('preview__bg_visible')) previewBg.classList.remove("preview__bg_visible");
        });
      }
    }
    // TODO: Remove after promo <<<
  }
  if (document.querySelector(".birthday-21")) {
    const categoryItems = Array.from(document.querySelectorAll(".preview__item"));
    categoryItems.forEach((item) => {
      $(item).waypoint({
        handler: function (direction) {
          categoryItems.forEach((el) =>
            el.classList.remove("in-view")
          );
          if (direction === "down") {
            categoryItems.forEach((el) =>
              el.classList.remove("in-view")
            );
            if (!item.classList.contains('in-view')) item.classList.add("in-view");
          } else if (direction === "up") {
            categoryItems.forEach((el) =>
              el.classList.remove("in-view")
            );
            if (!item.classList.contains('in-view')) item.classList.add("in-view");
          }
        },
        offset: "30%",
      });
    }); 
  }
  if (document.querySelector(".birth")) {
    const animItems = Array.from(document.querySelectorAll(".categories__link"));
    animItems.push(document.querySelector(".instalment__wrapper"));
    animItems.forEach((item) => {
      if (item) {
        item.classList.add("wait-view");
        $(item).waypoint({
          handler: function (direction) {
            if (direction === "down") {
              if (!item.classList.contains('in-view')) item.classList.add("in-view");
            } else if (direction === "up") {
              if (!item.classList.contains('in-view')) item.classList.add("in-view");
            }
          },
          offset: "80%",
          group: "categories-link"
        });
      }
    }); 
  }
  // Sidebar Banner
  if (document.querySelector('.sidebar-banner')) {
    const elClass = 'sidebar-banner';
    const sidebarBanner = Array.from(document.querySelectorAll(`.${elClass}`));
    $(".section__sidebar").waypoint({
      handler: function (direction) {
        if (direction === "down") {
          sidebarBanner.forEach((el) => el.classList.add(`${elClass}_visible`));
        }
        //else if (direction === 'up') {}
      },
      offset: "60%",
    });
  }
  if (document.querySelector('.online-plan__wrapper')) {
    $(".online-plan__wrapper").waypoint({
      handler: function (direction) {
        if (direction === "down") {
          $(".online-plan__wrapper").addClass("visible");
        }
      },
      offset: "60%",
    });
  }
  // Price Range with columns (noUiSlider) !!! ONLY FOR LOCAL DEV
  /* if (document.querySelector(".price-range")) {
    const priceRange = document.querySelectorAll(".price-range");
    priceRange.forEach(function (item) {
      let slider = item.querySelector(".price-range__slider"),
        inputMin = item.querySelector(".price-range__input--min"),
        stepVal = item.getAttribute("data-step"),
        minVal = item.getAttribute("data-min"),
        inputMax = item.querySelector(".price-range__input--max"),
        maxVal = item.getAttribute("data-max");
      createRangeSlider(slider, minVal, maxVal, inputMin, inputMax, stepVal);
    });
  } */
  if (document.querySelector('.btn-loader')) {
    // Для запуска лоадера на конкретной кнопке
    // Выбираем нужную кнопку
    const exampleBtn = document.querySelector(".btn-loader");
    // Для запуска используем функцию runBtnLoader и передаем в нее саму кнопку
    runBtnLoader(exampleBtn); // <-- FOR RUN
    // После того как требуется отключить лоадер, используем функцию offBtnLoader
    //offBtnLoader(exampleBtn); // <-- FOR OFF
  }

  if (document.querySelector('.section.popular .slider-popular')) {
    const popularSections = Array.from(document.querySelectorAll(".section.popular"));
    popularSections.forEach((section) => {
      if (section.querySelector(".slider-popular")) {
        const popularWrapper = section.querySelector('.popular__wrapper');
        const btnNext = popularWrapper.querySelector('.product-slider__popular__next');
        const btnPrev = popularWrapper.querySelector('.product-slider__popular__prev');
        const popularSlider = popularWrapper.querySelector('.slider-popular');
        const swiperPopular = new Swiper(popularSlider, {
          slidesPerView: 'auto',
          spaceBetween: 20,
          navigation: {
            nextEl: btnNext,
            prevEl: btnPrev
          }
        });
      }
    });
  }
  if (document.querySelector('.section.lifestyle .slider-lifestyle')) {
    const lifestyleWrapper = document.querySelector(".lifestyle__wrapper");
    const btnNext = lifestyleWrapper.querySelector('.product-slider__lifestyle__next');
    const btnPrev = lifestyleWrapper.querySelector('.product-slider__lifestyle__prev');
    const lifestyleSlider = lifestyleWrapper.querySelector('.slider-lifestyle');
    const swiperLifestyle = new Swiper(lifestyleSlider, {
      slidesPerView: "auto",
      spaceBetween: 20,
      navigation: {
        nextEl: btnNext,
        prevEl: btnPrev,
      },
      breakpoints: {
        575: {
          spaceBetween: 12,
        },
      },
    });
  }
  document.addEventListener("click", (e) => {
    if (e.target.classList.contains("how-get__btn")) {
      $('.how-get__spoiler').slideDown(500);
      $('.how-get__btn').slideUp()
    }
  });
  if (document.querySelector('.key-visual')) {
    const key = document.querySelector('.key-visual');
    setTimeout(() => {
      key.classList.add('key-visual_start');
    }, 100);
    setTimeout(() => {
      key.classList.add("key-visual_continue");
    }, 700);
  }

  const popularGrids = Array.from(document.querySelectorAll(".popular-grid"));
  let windowInnerWidthForGrid = window.innerWidth;
  popularGrids.forEach((wrapper) => {
    const optionalGrid = wrapper.querySelector(".popular-grid-optional");
    if (optionalGrid) {
      const btn = optionalGrid.querySelector(".popular-grid-optional__trigger");
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        if (btn.classList.contains('is-opened')) {
          //toggleText(btn);
          btn.classList.remove("is-opened");

          const cards = Array.from(wrapper.querySelectorAll(".popular-card:not(.popular-card--mid)"));
          cards.forEach((card) => {
            if (card.classList.contains("is-optional")) {
              animateHeightNull(card);
            }
          });
        } else {
          //toggleText(btn);
          btn.classList.add("is-opened");

          const cards = Array.from(wrapper.querySelectorAll(".popular-card:not(.popular-card--mid)"));
          cards.forEach((card) => {
            card.classList.remove("is-optional");
            if (card.classList.contains("is-hidden")) {
              card.classList.add("is-optional");
              animateAutoHeight(card, 8);
            }
          });
        }
      });
      window.addEventListener("resize", (e) => {
        if (window.innerWidth !== windowInnerWidthForGrid) {
          windowInnerWidthForGrid = window.innerWidth;
          const cards = Array.from(wrapper.querySelectorAll(".popular-card:not(.popular-card--mid)"));
          cards.forEach((card) => {
            card.classList.remove("is-optional");
            card.removeAttribute("style");
          });
          if (btn.classList.contains("is-opened")) {
            cards.forEach((card) => {
              if (card.classList.contains("is-hidden")) {
                card.classList.add("is-optional");
                card.style.height = "auto";
                card.style.marginBottom = "8px";
              }
            });
          }
        }
      });
    }
  });
  function toggleText(elem) {
    elem.classList.toggle("is-opened");
    const textDefault = elem.textContent;
    elem.textContent = elem.dataset.toggleText;
    elem.dataset.toggleText = textDefault;
  }
  function animateAutoHeight(elem, marginBottom) {
    var el = $(elem),
      curHeight = 0,
      autoHeight = el.css('height', 'auto').height();
    el.height(curHeight).animate({ height: autoHeight, marginBottom }, 400, function() {
      el.css('height', 'auto')
    });
  }
  function animateHeightNull(elem) {
    var el = $(elem),
      curHeight = el.height();
    el.height(curHeight).animate({ height: 0, margin: 0 }, 400, function () {
      //el.css('height', 'auto')
    });
  }
  //if (document.querySelector(".popup-step")) {
  //  const overlay = document.querySelector(".popup-overlay");
  //  const popups = Array.from(document.querySelectorAll(".popup-step"));
  //  let activePopup = null;
  //  popups.forEach((popup, ind) => {
  //    const id = popup.id ? popup.id : `popup-${ind}`;
  //    if (document.querySelector(`[data-popup="${id}"]`)) {
  //      const triggers = Array.from(document.querySelectorAll(`[data-popup="${id}"]`));
  //      triggers.forEach((trigger) => {
  //        trigger.addEventListener("click", () => {
  //          if (overlay.classList.contains("popup--hidden")) {
  //            overlay.classList.remove("popup--hidden");
  //            bodyFix(true);
  //          }
  //          if (!!activePopup) activePopup.classList.remove("active");
  //          if (!popup.classList.contains("active")) popup.classList.add("active");
  //          activePopup = popup;
  //        });
  //      })
  //    }
  //  });
  //}
  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-popup]")) {
      const trigger = e.target.closest("[data-popup]");
      const targetId = trigger.dataset.popup;
      openPopup(targetId);
    }
    if (e.target.hasAttribute("data-close") || e.target.classList.contains("popup-overlay")) {
      if (!!activePopup) {
        activePopup.classList.remove("active");
        activePopup = null;
      }
      document.querySelector(".popup-overlay").classList.add("popup--hidden");
      bodyFix(false);
    }
    if (e.target.closest(".notify__close")) {
      const closeBtn = e.target.closest(".notify__close");
      const notify = closeBtn.closest(".notify");
      $(notify).slideUp(400, () => {
        //notify.parentElement.removeChild(notify);
      });
    }
  });
  if (document.querySelector("[data-subpopup]")) {
    const subpopups = document.querySelectorAll('[data-subpopup]');
    subpopups.forEach((subpopup) => {
      const id = subpopup.id ? subpopup.id : null;
      if (document.querySelector(`[data-subpopup="${id}"]`)) {
        const trigger = document.querySelector(`[data-subpopup="${id}"]`);
        const backBtn = subpopup.querySelector("[data-back]");
        trigger.addEventListener("click", () => {
          if (subpopup.classList.contains("popup--hidden")) subpopup.classList.remove("popup--hidden");
        });
        backBtn.addEventListener("click", () => {
          if (!subpopup.classList.contains("popup--hidden"))
            subpopup.classList.add("popup--hidden");
        });
      }
    })
  }
  // 
  if (document.querySelector(".catalog-list-header") && document.querySelector(".catalog-list-area")) {
    const classNames = {
      header: "catalog-list-header",
      btn: "catalog-list-header__switch",
      list: "catalog-list-area",
    };
    const catalogListHeader = document.querySelector(`.${classNames.header}`);
    const catalogListArea = document.querySelector(`.${classNames.list}`);
    const triggerBtn = catalogListHeader.querySelector(`.${classNames.btn}`);
    if (triggerBtn.classList.contains(`${classNames.btn}--hidden`)) {
      console.log("OK")
      $(catalogListArea).slideUp();
    }
    triggerBtn.addEventListener("click", () => {
      //catalogListArea.classList.toggle(classNames.list + '--hidden');
      triggerBtn.classList.toggle(classNames.btn + "--hidden");
      if (triggerBtn.classList.contains(`${classNames.btn}--hidden`)) {
        $(catalogListArea).slideUp();
      } else {
        $(catalogListArea).slideDown();

      }
    })
  }
  // Динамический сбор заголовков H2 из статьи и преобразование в ссылки
  if (document.querySelector(".post-info__list") && document.querySelector(".post-body h2")) {
    const listLinks = document.querySelector(".post-info__list");
    const postContent = document.querySelector(".post-body");
    const titles = Array.from(postContent.querySelectorAll("h2"));
    document.documentElement.style.scrollBehavior = "smooth";
    titles.forEach((title, index) => {
      let idLink;
      if (title.id) {
        idLink = title.id;
      } else {
        idLink = `post-link-${index}`
        title.id = idLink;
      }
      const newItem = document.createElement("li");
      newItem.classList.add("post-info__item");
      const newLink = document.createElement("a");
      newLink.innerText = title.innerText;
      newLink.setAttribute("href", `#${idLink}`);
      newItem.append(newLink);
      listLinks.append(newItem);
    });
  }
  //
  const toggleShows = document.querySelectorAll("[data-toggle-show]");
  toggleShows.forEach((input) => {
    const target = document.querySelector(`#${input.dataset.toggleShow}`);
    if (input.checked) target.classList.add("is-show");
    if (!input.checked) target.classList.remove("is-show");
    input.addEventListener("change", (e) => {
      if (input.checked) target.classList.add("is-show");
      if (!input.checked) target.classList.remove("is-show");
    })
  });
  // Валидация
  if (document.querySelector("[data-validate]")) {
    const validateElems = Array.from(document.querySelectorAll("[data-validate]"));
    validateElems.forEach((elem) => {
      new NeedValidate(elem);
    });
  }

  if (document.querySelector(".brandszone-btn")) {
    const prevBtn = document.querySelector(".brandszone-btn_prev");
    prevBtn.classList.add("brandszone-btn_disable");
    const nextBtn = document.querySelector(".brandszone-btn_next");
    const container = prevBtn.parentElement;
    const items = Array.from(container.querySelectorAll(".brandszone__item"));
    const scrollHandle = debounce(() => {
      const scrollWidth = container.scrollWidth;
      const scrollLeft = container.scrollLeft;
      nextBtn.classList.remove("brandszone-btn_disable");
      prevBtn.classList.remove("brandszone-btn_disable");
      if (scrollWidth - scrollLeft - window.innerWidth - 20 < 0) {
        nextBtn.classList.add("brandszone-btn_disable");
      }
      if (scrollLeft < 20) {
        prevBtn.classList.add("brandszone-btn_disable");
      }
    }, 200);
    container.addEventListener("scroll", (e) => {
      scrollHandle();
    });
    prevBtn.addEventListener("click", (e) => {
      const actualLeftScroll = container.scrollLeft;
      items.forEach((item, ind) => {
        if (item.offsetLeft - actualLeftScroll < 40 && ind > 0) {
          items[ind - 1].scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "start"
          });
        }
      })
    });
    nextBtn.addEventListener("click", (e) => {
      const actualLeftScroll = container.scrollLeft;
      items.forEach((item, ind) => {
        if (item.offsetLeft - actualLeftScroll < 40) {
          items[ind + 1].scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "start"
          });
        }
      })
    });
  }

  if (document.querySelector(".products-filters")) {
    const unupdatedEl = document.querySelector(".inner-page__body");
    let filter = document.querySelector(".products-filters");
    let scrollFilter = 0;


    const onScrollFilter = (e) => {
      scrollFilter = e.target.scrollTop;
    }
    const updateFilter = () => {
      filter.removeEventListener('scroll', onScrollFilter);
      filter = document.querySelector(".products-filters");
      filter.scrollTop = scrollFilter;
      filter.addEventListener('scroll', onScrollFilter);
      // Line need move to
      $(".products-filters__result__remove").on("click", function (e) {
        e.stopPropagation();
      });
    };
    filter.addEventListener('scroll', onScrollFilter);
    let updateObserver = new MutationObserver((mutations) => {
      if (!!document.querySelector(".products-filters") && filter !== document.querySelector(".products-filters")) {
        console.log('Last pos scroll: ' + scrollFilter);
        updateFilter()
        console.log('Update scroll to:' + scrollFilter);
      }
    });

    updateObserver.observe(unupdatedEl, {
      childList: true,
      subtree: true,
    });
  }
  addSwipeSvg();

  if (document.querySelector(".taps-block--superdiscount")) {
    runTapsBlock();
  }

  const faqs = Array.from(document.querySelectorAll(".faq__list"));
  faqs.forEach((el) => {
    const items = Array.from(el.querySelectorAll(".faq__item"));
    items.forEach((item) => {
      if (!item.classList.contains("faq__item--opened")) {
        item.querySelector(".faq__body").style.display = "none";
      }
    });
  })

  window.addEventListener("click", (e) => {
    if (e.target.closest(".insurance-list__header")) {
      const parent = e.target.closest(".insurance-list__item");
      const body = parent.querySelector(".insurance-list__body");
      $(body).slideToggle();
      parent.classList.toggle("is-showed");
    }
    //if (e.target.closest("[data-iframe-open-fullscreen]")) {
    //  const btnIframeOpen = e.target.closest("[data-iframe-open-fullscreen]");
    //  const idFrame = btnIframeOpen.dataset.iframeOpenFullscreen;
    //  const targetFrame = document.querySelector(`#${idFrame}`);
    //  if (targetFrame) {
    //    if (targetFrame.requestFullscreen) {
    //      targetFrame.requestFullscreen();
    //    } else if (targetFrame.webkitRequestFullscreen) { /* Safari */
    //      targetFrame.webkitRequestFullscreen();
    //    } else if (targetFrame.msRequestFullscreen) { /* IE11 */
    //      targetFrame.msRequestFullscreen();
    //    }
    //  }
    //}
    if (e.target.closest(".faq__header")) {
      const faqHeader = e.target.closest(".faq__header");
      const item = faqHeader.closest(".faq__item");
      const body = item.querySelector(".faq__body");
      if (item.classList.contains("faq__item--opened")) {
        item.classList.remove("faq__item--opened");
        $(body).slideUp();
      } else {
        item.classList.add("faq__item--opened");
        $(body).slideDown();

      }
    }
  });

  tipAlign();
  window.addEventListener("resize", (e) => {
    tipAlign();
  });
  
});

function tipAlign() {
  const infoPopups = Array.from(document.querySelectorAll(".info-popup"));
  const tips = Array.from(document.querySelectorAll(".tip"));
  const allTips = [...tips, ...infoPopups];
  allTips.forEach((el) => {
    el.classList.remove("is-aligned");
    el.classList.remove("is-aligned--right");
  });
  if (window.innerWidth < 767) {
    allTips.forEach((el) => {
      el.classList.add("is-aligned");
      if (el.getBoundingClientRect().left - 20 > window.innerWidth / 2) {
        el.classList.add("is-aligned--right");
      }
    });
  }
  tippy('[data-tippy-content]');
  const tippiesHtml = Array.from(document.querySelectorAll("[data-tippy-template]"));
  tippiesHtml.forEach((tippyHtml) => {
    const template = tippyHtml.querySelector(".template");
    template.style.display = "block";
    tippy(tippyHtml, {
      content: template,
      interactive: true,
      delay: [null, 200],
      //showOnCreate: true,
      //hideOnClick: 'toggle',
      //trigger: "click",
      appendTo: () => document.body
    });
  })
}

function openPopup(id) {
  const overlay = document.querySelector(".popup-overlay");
  const targetId = id;
  const popup = document.querySelector(`#${targetId}`);
  if (popup) {
    if (overlay && overlay.classList.contains("popup--hidden")) {
      overlay.classList.remove("popup--hidden");
      bodyFix(true);
    }
    if (!!activePopup) activePopup.classList.remove("active");
    if (!popup.classList.contains("active")) popup.classList.add("active");
    activePopup = popup;
  }
}

let isStartedTestTimer = false;
function runTestTimer() {
  if (isStartedTestTimer) return;

  if (document.querySelector("[data-test-timer]")) {
    const timerElem = document.querySelector("[data-test-timer]");
    const count = +timerElem.dataset.testTimer;
    const start_time = new Date();
    const stop_time = start_time.setSeconds(start_time.getSeconds() + count);
    timerElem.dispatchEvent(new Event("testTimerStart", {
      bubbles: true,
    }));

    let countdown = setInterval(function () {
      const now = new Date().getTime();
      const remain = stop_time - now;
      let min = Math.floor((remain % (1000 * 60 * 60)) / (1000 * 60));
      let sec = Math.floor((remain % (1000 * 60)) / 1000);
      // если значение текущей секунды меньше 10, добавляем вначале ведущий ноль
      sec = sec < 10 ? "0" + sec : sec;
      timerElem.innerHTML = min + ":" + sec;
      if (remain < 0) {
        clearInterval(countdown);
        timerElem.innerHTML = '<span class="color-red">00:00</span>';
        isStartedTestTimer = false;
        timerElem.dispatchEvent(new Event("testTimerEnd", {
          bubbles: true,
        }));
      }
    }, 1000);
    runNotifyTimer();
    isStartedTestTimer = true;
  }
}
function runNotifyTimer() {
  if (document.querySelector("[data-notify-timer]")) {
    const notifies = Array.from(document.querySelectorAll("[data-notify-timer]"));
    notifies.forEach((notify) => {
      const date = new Date();
      const dateEnd = new Date();
      const startSec = +notify.dataset.notifyAfter ?? 0;
      const count = +notify.dataset.notifyTimer ?? 0;
      const start_time = date.setSeconds(date.getSeconds() + startSec);
      const stop_time = dateEnd.setSeconds(dateEnd.getSeconds() + count + startSec);
      let isShowing = false;
      let countdown = setInterval(function () {
        const now = new Date().getTime();
        const remain = stop_time - now;
        if (now > start_time) {
          if (!isShowing) {
            showNotifiyElem(notify);
          }
          isShowing = true;
          if (remain < 0) {
            closeNotifiyElem(notify);
            clearInterval(countdown);
          }
        }
      }, 1000);
    });
  }
}
function showNotifiyElem(notify) {
  $(notify).slideDown();
  notify.dispatchEvent(new CustomEvent("notifyShow", {
    detail: {
      id: notify.getAttribute("data-notify-id") || ""
    },
    bubbles: true,
  }));
}
function closeNotifiyElem(notify) {
  $(notify).slideUp();
  notify.dispatchEvent(new CustomEvent("notifyClose", {
    detail: {
      id: notify.getAttribute("data-notify-id") || ""
    },
    bubbles: true,
  }));
}
function runTestNotifies() {
  if (isStartedTestTimer) return;
  if (document.querySelector("[data-test-notify]")) {
    const notifies = Array.from(document.querySelectorAll("[data-test-notify]"));
    notifies.forEach((notify) => {

    });
  }
}
function closeNotify(e) {

}

function runTapsBlock(activeIndex) {
  const wrapper = document.querySelector(".taps-block--superdiscount");
  if (wrapper.classList.contains("initialized")) return;
  wrapper.classList.add("initialized");
  const form = wrapper.querySelector("form");
  const tapsCounts = Array.from(wrapper.querySelectorAll(".taps-block__item"));
  const btnBack = wrapper.querySelector(".taps-block__back");
  const btnsNext = Array.from(wrapper.querySelectorAll("[data-taps-next]"));
  const taps = Array.from(wrapper.querySelectorAll(".tap-screen"));
  let tapsIndex = activeIndex ? +activeIndex : 0;
  taps.forEach((el, ind) => {
    const btn = el.querySelector("[data-taps-next]");
    console.log(btn)
    if (btn && btn.hasAttribute("disabled")) {
      btn.setAttribute("data-disabled-toggle", true);
    }
    if (ind !== tapsIndex) {
      $(el).hide();
    } else {
      showSlide();
    }
    Array.from(el.querySelectorAll("input")).forEach((input) => {
      input.addEventListener("change", (e) => {
        if (el.querySelector("input:checked") && btn && btn.hasAttribute("data-disabled-toggle")) {
          btn.removeAttribute("disabled");
        } else if (btn && btn.hasAttribute("data-disabled-toggle")) {
          btn.setAttribute("disabled", true);
        }
      });
    });
  });
  btnsNext.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      if (btn.dataset.tapsNext === "end") {
        showSlide(true);
      } else {
        tapsIndex += 1;
        showSlide();
      }
    });
  });
  btnBack.addEventListener("click", (e) => {
    const activeTap = taps[tapsIndex];
    const targetChange = activeTap.querySelector("[data-taps-change-before-choice]");
    if (targetChange) {
      targetChange.textContent = targetChange.dataset.tapsChangeBeforeChoice;
      activeTap.querySelectorAll("input:checked").forEach((input) => input.checked = false);
    }
    tapsIndex -= 1;
    showSlide();
  });
  function showSlide(isEnd) {
    if (0 === tapsIndex) {
      btnBack.classList.add("btn--hide");
    } else {
      btnBack.classList.remove("btn--hide");

    }
    tapsCounts.forEach((el, ind) => {
      if (isEnd) {
        el.classList.remove("active");
        el.classList.add("success");
      } else {
        if (ind < tapsIndex) {
          el.classList.remove("active");
          el.classList.add("success");
        }
        if (ind === tapsIndex) {
          el.classList.add("active");
          el.classList.remove("success");
  
        }
        if (ind > tapsIndex) {
          el.classList.remove("active");
          el.classList.remove("success");
        }
      }
    });
    taps.forEach((el, ind) => {
      if (ind === tapsIndex) {
        $(el).slideDown();
      } else {
        $(el).slideUp();

      }
    });
  }
  form.addEventListener("change", (e) => {
    const input = e.target;
    const wrapper = input.parentElement;
    const screen = input.closest(".tap-screen");
    if (screen) {
      if (screen.querySelector("[data-taps-change-after-choice]")) {
        if (screen.querySelector("input:checked")) {
          const targetChange = screen.querySelector("[data-taps-change-after-choice]");
          targetChange.textContent = targetChange.dataset.tapsChangeAfterChoice;
        } else {
          const targetChange = screen.querySelector("[data-taps-change-before-choice]");
          targetChange.textContent = targetChange.dataset.tapsChangeBeforeChoice;
        }
      }
    }
    if (wrapper.querySelector("[data-tariff-image]")) {
      const source = wrapper.querySelector("[data-tariff-image]");
      const target = form.querySelector("[data-tariff-image-total");
      target.setAttribute("src", source.getAttribute("src"));
      target.setAttribute("alt", source.getAttribute("alt"));
    }
    if (wrapper.querySelector("[data-tariff-price]")) {
      const source = wrapper.querySelector("[data-tariff-price]");
      const target = form.querySelector("[data-tariff-price-total");
      target.textContent = source.textContent;

    }
    if (wrapper.querySelector("[data-tariff-title]")) {
      const source = wrapper.querySelector("[data-tariff-title]");
      const targets = Array.from(form.querySelectorAll("[data-tariff-title-total"));
      targets.forEach((target) => {
        target.textContent = source.textContent;
      });

    }
    if (wrapper.querySelector("[data-phone-image]")) {
      const source = wrapper.querySelector("[data-phone-image]");
      const targets = Array.from(form.querySelectorAll("[data-phone-image-total"));
      targets.forEach((target) => {
        target.setAttribute("src", source.getAttribute("src"));
        target.setAttribute("alt", source.getAttribute("alt"));
      });

    }
    if (wrapper.querySelector("[data-phone-price]")) {
      const source = wrapper.querySelector("[data-phone-price]");
      const targets = Array.from(form.querySelectorAll("[data-phone-price-total"));
      targets.forEach((target) => {
        target.textContent = source.textContent;
      });

    }
    if (wrapper.querySelector("[data-phone-title]")) {
      const source = wrapper.querySelector("[data-phone-title]");
      const targets = Array.from(form.querySelectorAll("[data-phone-title-total"));
      targets.forEach((target) => {
        target.textContent = source.textContent;
      });

    }
    if (wrapper.querySelector("[data-sale-title]")) {
      const source = wrapper.querySelector("[data-sale-title]");
      const targets = Array.from(form.querySelectorAll("[data-sale-title-total"));
      targets.forEach((target) => {
        target.textContent = source.textContent;
      });

    }
    if (wrapper.querySelector("[data-sale-image]")) {
      const source = wrapper.querySelector("[data-sale-image]");
      const targets = Array.from(form.querySelectorAll("[data-sale-image-total"));
      targets.forEach((target) => {
        target.setAttribute("src", source.getAttribute("src"));
        target.setAttribute("alt", source.getAttribute("alt"));
      });

    }
  });
}

// Add svg finger in table default
function addSwipeSvg() {
  const tables = Array.from(document.querySelectorAll(".table-default"));
  tables.forEach((table) => {
    const wrapperSvg = document.createElement("div");
    wrapperSvg.classList.add("table-default__swipe");
    wrapperSvg.innerHTML = `
      <svg class="svg-item" viewBox="-30 -15 186.88 279.84"><path class="back-secondary" d="M59.83 38.57c0-13.21 11.2-23.92 25-23.92s25 10.71 25 23.92c0 3.87 1.48 3.19 2.52.2a29.15 29.15 0 1 0-55.09 0c1.08 2.97 2.57 3.7 2.57-.2Z"/><path class="back-primary" d="M163 126.89V111a11.35 11.35 0 0 0-19.84-7.55v-2.16a13.22 13.22 0 0 0-21.92-10v-2.45a13.22 13.22 0 0 0-23.16-8.73V41.68a13.23 13.23 0 0 0-26.46 0v91.88a87.41 87.41 0 0 1-6.2-8.32c-5-7.65-15.3-15.3-25.64-11-6.25 2.62-2.83 9.4.86 14.35a63.84 63.84 0 0 0 3.07 7.77c2.69 5.38 6 8.06 8.89 20.26s8.68 24.81 21.3 34.11c0 0 2.48 9.1 8.47 9.1h62.85s11.58-5.79 15.3-36.39 2.48-36.55 2.48-36.55Z"/></svg>
    `;
    table.appendChild(wrapperSvg);
    $(wrapperSvg.querySelector("svg")).waypoint({
      handler: function(direction) {
        if(direction === 'down') {
          wrapperSvg.querySelector("svg").classList.add("active");
          setTimeout(() => {
            wrapperSvg.classList.add("is-swiped")
          }, 2000)
        } else if(direction === 'up') {
          wrapperSvg.querySelector("svg").classList.add("active");
          setTimeout(() => {
            wrapperSvg.classList.add("is-swiped")
          }, 2000)
        }
      },
      offset: '70%'
    });
  })
}
// Check banner
function equalizationHeaderWithBanner() {
  //const header = document.querySelector("header");
  if (document.querySelector(".header-attention")) {
    const headerAttention = document.querySelector(".header-attention");
    const main = document.querySelector(".main");
    main.classList.add("with-attention");
    main.style.setProperty("--attention-height", headerAttention.offsetHeight + "px")
  } else {
    document.addEventListener("initHeaderAttention", () => {
      if (!!document.querySelector(".header-attention")) {
        const headerAttention = document.querySelector(".header-attention");
        if (!headerAttention.classList.contains("header-attention__hidden")) {
          const main = document.querySelector(".main");
          main.classList.add("with-attention");
          main.style.setProperty("--attention-height", headerAttention.offsetHeight + "px")
        }
      }
      console.log("Ready Header Attention")
    })
    //let updateObserver = new MutationObserver((mutations) => {
    //  if (!!document.querySelector(".header-attention")) {
    //    const headerAttention = document.querySelector(".header-attention");
    //    if (!headerAttention.classList.contains("header-attention__hidden")) {
    //      const main = document.querySelector(".main");
    //      main.classList.add("with-attention");
    //      main.style.setProperty("--attention-height", headerAttention.offsetHeight + "px")
    //      updateObserver.disconnect();
    //    }
    //  }
    //});
    //updateObserver.observe(header, {
    //  attributes: false,
    //  childList: true,
    //  subtree: true,
    //});
    //setTimeout(() => {
    //  updateObserver.disconnect();
    //}, 10000)
  }
}
// Validate
class NeedValidate {
  constructor(elem) {
    this.elem = elem;
    this.parent = elem.parentElement;
    this.isShowWarning = false;
    this.warningEl = document.createElement('p');
    this.warningEl.classList.add('validate__warn');
    this.warningEl.innerText = elem.dataset.validateText ? elem.dataset.validateText : `Некорректный формат.`;
    this.elem.after(this.warningEl);
    this.warningEl.style.display = 'none';
    this.timer = null;
    this.events();
  }
  validate() {
    const newValue = this.elem.value;
    const endValue = newValue.replace(/[^а-яёА-ЯЁЎў ]/g, "");
    if (newValue !== endValue) {
      this.showWarning();
      this.elem.value = endValue;
    } else {
      this.hiddenWarning();
    }
  }
  showWarning() {
    this.warningEl.style.display = 'block';
    this.elem.style.borderColor = 'red';
    setTimeout(() => {
      this.elem.style.borderColor = null;
    }, 400);
    this.isShowWarning = true;
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        $(this.warningEl).fadeOut(800);
      }, 1000);
    } else {
      this.timer = setTimeout(() => {
        $(this.warningEl).fadeOut(800);
      }, 1000);
    }
  }
  hiddenWarning() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.warningEl.style.display = 'none';
      this.elem.style.borderColor = null;
    }
  }
  events() {
    this.elem.addEventListener('input', (e) => {
      this.validate();
    });
  }
}

function checkWidthScrollBar() {
  let div = document.createElement("div");
  div.style.overflowY = "scroll";
  div.style.width = "50px";
  div.style.height = "50px";
  document.body.append(div);
  widthScrollBar = div.offsetWidth - div.clientWidth;
  div.remove();
}

// FIRM SLIDERS FUNTIONS START
function setProgress(progressLine, slides, index) {
  if (!!progressLine) {
    let sumSlideMin;
    let sumSlideMax;
    if (pageFirm === "xiaomi") {
      sumSlideMin = 3;
      sumSlideMax = 4;
    }
    if (pageFirm === "huawei") {
      sumSlideMin = 2;
      sumSlideMax = 3;
    }
    if (
      pageFirm === "apple" ||
      pageFirm === "samsung" ||
      pageFirm === "honor-page" ||
      pageFirm === "tcl-page" ||
      pageFirm === "february-page" ||
      pageFirm === "women-page" ||
      pageFirm === "birth-page" ||
      pageFirm === "yandex-page"
    ) {
      sumSlideMin = 2;
      sumSlideMax = 4;
    }
    const slidesNum = window.innerWidth < 1200 ? sumSlideMin : sumSlideMax;
    const calc = Math.trunc((index / (slides - slidesNum)) * 100);
    progressLine.style.width = `${calc}%`;
  }
}
// Функция createFirmSlider используется только внутри updateFirmPopularSlider
function createFirmSlider(elem) {
  let slidesShow;
  let responsiveFirm = [];
  let prevArrowSelector =
    '<button class="popular__arrow popular__arrow--prev"></button>';
  let nextArrowSelector =
    '<button class="popular__arrow popular__arrow--next"></button>';
  if (pageFirm === "xiaomi") {
    slidesShow = 4;
    responsiveFirm.push({
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
      },
    });
  }
  const configTcl = {
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: '<button class="slider__arrow slider__arrow--prev"></button>',
    nextArrow: '<button class="slider__arrow slider__arrow--next"></button>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    appendArrows: pageFirm === "tcl-page" ? ".tcl-popular-slider__arrows" : pageFirm === "yandex-page" ? ".yandex-popular-slider__arrows" : pageFirm === "women-page" ? ".women-popular-slider__arrows" : pageFirm === "birth-page" ? ".birth-popular-slider__arrows" : ".february-popular-slider__arrows",
  };
  if (pageFirm === "huawei") {
    slidesShow = 3;
    responsiveFirm.push({
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
      },
    });
  }
  if (
    pageFirm === "apple" ||
    pageFirm === "samsung" ||
    pageFirm === "honor-page"
  ) {
    prevArrowSelector =
      '<button class="slider__arrow slider__arrow--prev"></button>';
    nextArrowSelector =
      '<button class="slider__arrow slider__arrow--next"></button>';
    slidesShow = 4;
    responsiveFirm.push({
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
      },
    });
  }
  const config = {
    infinite: false,
    slidesToShow: slidesShow,
    slidesToScroll: 1,
    prevArrow: prevArrowSelector,
    nextArrow: nextArrowSelector,
    responsive: responsiveFirm,
  };
  if (pageFirm === "tcl-page" || pageFirm === "yandex-page" || pageFirm === "birth-page" || pageFirm === "february-page" || pageFirm === "women-page") {
    firmSlider = $(elem).slick(configTcl)
  } else {
    firmSlider = $(elem).slick(config);
  }
  return firmSlider;
}
// ДЛЯ ОБНОВЛЕНИЯ СЛАЙДЕРА НА СТРАНИЦАХ Apple, Samsung, Xiaomi и Huawei
// Вызываем функцию updateFirmPopularSlider()
function updateFirmPopularSlider() {
  let slider;
  let progressLine;
  let slides;
  let selectorSlider;
  let mobileBp;
  if (document.querySelector(".birthday-mts--23") && document.querySelector(".slider__list")) {
    const sliders = Array.from(document.querySelectorAll(".slider__list"));
    sliders.forEach((wrapList, index) => {
      const wrapper = wrapList.closest(".slider");
      slider = wrapper.querySelector(".slider__list");
      progressLine = wrapper.querySelector(`.slider__line`);
      slides = slider.querySelectorAll(".slider__item").length;
      const appendArrows = wrapper.querySelector(".birth-popular-slider__arrows");
      const configBirthSlider = {
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: '<button class="slider__arrow slider__arrow--prev"></button>',
        nextArrow: '<button class="slider__arrow slider__arrow--next"></button>',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
        appendArrows: $(appendArrows)

      };

      if (firmSliders && firmSliders[index] !== undefined) {
        //firmSlider.slick("unslick");
        firmSliders[index].slick("unslick");
        setProgress(progressLine, slides, 0);
      }
      firmSliders[index] = $(slider).slick(configBirthSlider)
      $(slider).on(
        "beforeChange",
        function (event, slick, currentSlide, nextSlide) {
          setProgress(progressLine, slides, nextSlide);
        }
      );
      //console.log(slider)
    });


  }
  if (document.querySelector(".xiaomi") || document.querySelector(".huawei")) {
    const firm = document.querySelector(".xiaomi") ? "xiaomi" : "huawei";
    selectorSlider = document.querySelector(".xiaomi")
      ? ".xiaomi .popular__slider"
      : ".huawei .popular__list";
    slider = document.querySelector(selectorSlider);
    progressLine = document.querySelector(`.${firm} .popular__line`);
    slides = slider.querySelectorAll(".popular__slide").length;
    pageFirm = firm;
    mobileBp = firm === "xiaomi" ? 1001 : 768;
  }
  if (document.querySelector(".samsung") || document.querySelector(".apple")) {
    const firm = document.querySelector(".samsung") ? "samsung" : "apple";
    selectorSlider = `.${firm} .slider__list`;
    slider = document.querySelector(selectorSlider);
    progressLine = document.querySelector(`.${firm} .slider__line`);
    slides = slider.querySelectorAll(".slider__item").length;
    pageFirm = firm;
    mobileBp = 768;
  }
  if (document.querySelector(".honor-page") || document.querySelector(".tcl-page") || document.querySelector(".yandex-page") || document.querySelector(".birth-page") || document.querySelector(".february-page") || document.querySelector(".women-page")) {
    if (document.querySelector(".birthday-mts--23")) return;
    const firm = (() => {
      if (document.querySelector(".honor-page")) return "honor-page";
      if (document.querySelector(".tcl-page")) return "tcl-page";
      if (document.querySelector(".yandex-page")) return "yandex-page";
      if (document.querySelector(".birth-page")) return "birth-page";
      if (document.querySelector(".february-page")) return "february-page";
      if (document.querySelector(".women-page")) return "women-page";
    })();
    selectorSlider = `.${firm} .slider__list`;
    slider = document.querySelector(selectorSlider);
    progressLine = document.querySelector(`.${firm} .slider__line`);
    slides = slider.querySelectorAll(".slider__item").length;
    pageFirm = firm;
    mobileBp = 768;
  }
  if (pageFirm === "tcl-page" || pageFirm === "yandex-page" || pageFirm === "birth-page" || pageFirm === "february-page" || pageFirm === "women-page") {
    if (document.querySelector(".birthday-mts--23")) return;
    if (firmSlider !== undefined) {
      firmSlider.slick("unslick");
      setProgress(progressLine, slides, 0);
    }
    createFirmSlider(selectorSlider);
    $(selectorSlider).on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        setProgress(progressLine, slides, nextSlide);
      }
    );
  } else {
    if (window.innerWidth < mobileBp) {
      if (firmSlider !== undefined) {
        firmSlider.slick("unslick");
        setProgress(progressLine, slides, 0);
      }
    } else {
      if (firmSlider !== undefined) {
        firmSlider.slick("unslick");
        setProgress(progressLine, slides, 0);
      }
      createFirmSlider(selectorSlider);
      $(selectorSlider).on(
        "beforeChange",
        function (event, slick, currentSlide, nextSlide) {
          setProgress(progressLine, slides, nextSlide);
        }
      );
    }
  }

  
}

// FIRM SLIDERS FUNTIONS END


function runBtnLoader(btn) {
  if (!btn.classList.contains('loading')) {
    btn.classList.add('loading');
  }
}
function offBtnLoader(btn) {
  if (btn.classList.contains('loading')) {
    btn.classList.remove('loading');
  }
}
function brushCharts(charts, firstMin, firstMax, nowMin, nowMax, numCharts) {
  const offStartColumn = Math.round((numCharts / 100) * ((nowMin - firstMin) / ((firstMax - firstMin) / 100)));
  const offEndPercent = (firstMax - nowMax) / ((firstMax - firstMin) / 100)
  const offEndColumn = Math.round((numCharts / 100) * offEndPercent);
  const offEndFirstColumn = numCharts - offEndColumn;
  charts.forEach((chart, ind) => {
    if (ind >= offStartColumn && ind <= offEndFirstColumn) {
      chart.classList.add("price-range__chart__column--active");
    } else if (chart.classList.contains("price-range__chart__column--active")) {
      chart.classList.remove("price-range__chart__column--active");
    }
  });
  if (offEndFirstColumn === numCharts) charts[charts.length - 1].classList.add("price-range__chart__column--active");
  if (firstMin === 0 && 100 === offEndPercent) charts[0].classList.remove("price-range__chart__column--active");
}
function createRangeSlider(elem, minVal, maxVal, minInput, maxInput, stepVal) {
  const minValue = parseFloat(minVal);
  const maxValue = parseFloat(maxVal);
  let sliderInstance = noUiSlider.create(elem, {
    start: [minInput?.value || parseFloat(minVal), maxInput?.value || parseFloat(maxVal)],
    step: parseFloat(stepVal),
    connect: true,
    range: {
      'min': [minValue],
      'max': [maxValue]
    }
  });
  let charts = null;
  let numCharts = 0;
  if (elem.previousElementSibling && elem.previousElementSibling.classList.contains("price-range__chart")) {
    const parentCharts = elem.previousElementSibling;
    charts = Array.from(parentCharts.querySelectorAll('.price-range__chart__column'));
    numCharts = charts.length;
    brushCharts(charts, minValue, maxValue, minValue, maxValue, numCharts);
  }


  sliderInstance.on("update", function (values, handle) {
    const newMinVal = parseFloat(values[0]);
    const newMaxVal = parseFloat(values[1]);
    minInput.value = newMinVal;
    maxInput.value = newMaxVal;
    if (charts) brushCharts(charts, minValue, maxValue, newMinVal, newMaxVal, numCharts);
  });
  minInput.addEventListener('change', function () {
    sliderInstance.set([this.value, null]);
  });
  maxInput.addEventListener('change', function () {
    sliderInstance.set([null, this.value]);
  });
  return sliderInstance;
}
/*
var priceRange = document.querySelectorAll('.price-range');

priceRange.forEach(function (item) {
  let slider = item.querySelector(".price-range__slider"),
    inputMin = item.querySelector('.price-range__input--min'),
    stepVal = item.getAttribute("data-step"),
    minVal = item.getAttribute("data-min"),
    inputMax = item.querySelector('.price-range__input--max'),
    maxVal = item.getAttribute("data-max");
  createRangeSlider(slider, minVal, maxVal, inputMin, inputMax, stepVal);
})
*/
function toggleFiltersAnimations() {
  $('.products-filters').toggleClass('products-filters--no-animation');
}
function addMainSliderBgImage() {
  $('.main-slider__slide--bg').each(function () {
    let data = $(this).data('send');
    let bg = data.desktop;
    if (window.innerWidth < 1201) {
      bg = data.tablet;
    }
    if (window.innerWidth < 768) {
      bg = data.mobile;
    }
    $(this).css('backgroundImage', 'url(' + bg + ')');
  });
}
function initProductSlider() {
  $(".product-slider__outer").each(function () {
    var _this = $(this),
      slider = _this.find(".product-slider"),
      prevArrow = _this.find(".product-slider__controls__prev"),
      nextArrow = _this.find(".product-slider__controls__next");
    var params = {
      loop: false,
      slidesPerView: 3,
      spaceBetween: 30,
      navigation: {
        nextEl: nextArrow,
        prevEl: prevArrow,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 40,
        },
        767: {
          slidesPerView: 1,
          spaceBetween: 40,
        },
        1200: {
          slidesPerView: 2,
          spaceBetween: 12,
        }
      }
    };
    var sliderEntity = new Swiper(slider, params);
  });
}
function initMainSlider() {
  $(".main-slider").each(function () {
    /* source: https://gist.github.com/jasdeepkhalsa/767bfd5f24c7ecf09363 */
    function Timer(callback, delay) {
      var timerId, start, remaining = delay;
      this.pause = function () {
        window.clearTimeout(timerId);
        remaining -= new Date() - start;
      };
      this.resume = function () {
        start = new Date();
        window.clearTimeout(timerId);
        timerId = window.setTimeout(callback, remaining);
      };
      this.clear = function () {
        window.clearTimeout(timerId);
      }
      this.resume();
    }
    /* ------ */
    const backgrounds = $(this).find('.main-slider-bg');
    const content = $(this).find('.main-slider-content');
    const next = $(this).find('.main-slider__controls-btn--next');
    const prev = $(this).find('.main-slider__controls-btn--prev');
    const circle = $(this).find('.main-slider__controls-loader circle');
    const autoplaySpeed = 6000;
    let autoplayTimeout;
    const contentSlider = new Swiper(content, {
      direction: "vertical",
      loop: true,
      speed: 600,
      allowTouchMove: false,
    })
    const backgroundSlider = new Swiper(backgrounds, {
      loop: true,
      speed: 600,
      controller: {
        control: contentSlider
      },
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      on: {
        slideChange: () => {
          if (autoplayTimeout) autoplayTimeout.clear();
          autoplayTimeout = new Timer(function () {
            backgroundSlider.slideNext();
          }, autoplaySpeed);
          circle.stop().css({ 'stroke-dashoffset': '135px' });
          circle.animate({ 'stroke-dashoffset': '0px' }, autoplaySpeed);
        },
      }
    })
    contentSlider.controller.control = backgroundSlider;
    $(this).on('mouseover touchstart', () => {
      autoplayTimeout.pause();
      circle.pause();
    })
    $(this).on('mouseout touchend', () => {
      autoplayTimeout.resume();
      circle.resume();
    })
  })
}
function initSelects() {
  //if (!!isRunnedSelects) return;
  //isRunnedSelects = true;
  // TODO! CHECK WORK PRICE PRINTER
  console.log("Init selects run");  
  const selects = Array.from(document.querySelectorAll(".select"));
  selects.forEach((selectWrapper) => {
    const select = selectWrapper.tagName === "SELECT" ? selectWrapper : selectWrapper.querySelector("select");
    //if (!selectWrapper.classList.contains("pre-init")) {
    //  selectWrapper.classList.add("pre-init");
    //  const original = Object.getOwnPropertyDescriptor(
    //    HTMLSelectElement.prototype,
    //    "value"
    //  );
    //  const selectElem = select;
    //  if (!!selectElem) {
    //    Object.defineProperty(selectElem, "value", {
    //      get: original.get,
    //      set(val) {
    //        const old = this.value;
    //        const res = original.set.call(this, val);
    //        if (old != val) this.dispatchEvent(new Event("change"));
    //        return res;
    //      },
    //    });
    //  }

    //  select.addEventListener("change", (e) => {
    //    console.log(e)
    //  })
    //}

    if (!selectWrapper.classList.contains("initializated")) {
      selectWrapper.classList.add("initializated");
      const header = selectWrapper.querySelector(".select__header");
      const bodyUnit = Array.from(selectWrapper.querySelectorAll(".select__body__unit"));

      header.addEventListener("click", () => {
        selectWrapper.classList.toggle("select--active");
      });
      bodyUnit.forEach((el, ind) => {
        el.addEventListener("click", (e) => {
          const value = el.getAttribute("data-value") ?? "";
          selectWrapper.classList.toggle("select--active");
          bodyUnit.forEach((el) => {
            el.classList.remove("select__body__unit--active")
          });
          select.value = value;
          select.children[ind].selected = true;
          selectWrapper.classList.remove("select--placeholder");
          el.classList.add("select__body__unit--active");
          header.textContent = el.textContent;
          select.dispatchEvent(new Event("change"));
        });
      });
    }
    //select.addEventListener("change")
  })
  //$(".select").each(function () {
  //  if (!$(this).hasClass("initializated")) {
  //    $(this).addClass("initializated");
  //    var selectWrap = $(this),
  //      select = selectWrap.find("select"),
  //      header = selectWrap.find(".select__header"),
  //      bodyUnit = selectWrap.find(".select__body__unit");
  //    //console.log(select)
  
  //    //header.on('click', function () {
  //    //  selectWrap.toggleClass("select--active");
  //    //})
  //    //bodyUnit.on("click", function () {
  //    //  var value = $(this).attr("data-value");
  //    //  selectWrap.toggleClass("select--active");
  //    //  select.val(value).change();
  //    //})
  //    select.on("change", function (e) {
  //      //console.log(e.target.value)
  //      selectWrap.removeClass("select--placeholder");
  //      header.html($(this).children("option:selected").text());
  //      bodyUnit.removeClass('select__body__unit--active');
  //      bodyUnit.each(function () {
  //        if ($(this).attr("data-value") === select.val()) {
  //          $(this).addClass("select__body__unit--active");
  //        }
  //      })
  //    })
  //  }
  //});
  console.log("Init selects end");
}
//initSelects();
function showComparsionHeader() {
  $(window).on("load scroll resize", function () {
    var scroll = window.pageYOffset;
    let comparsionTableStart = $(".comparsion__table__start");
    if (comparsionTableStart.length > 0) {
      if (scroll > getCoords(comparsionTableStart[0]).top) {
        $(".comparsion-header:not(.comparsion-header--shown)").addClass("comparsion-header--shown");
      } else {
        $(".comparsion-header--shown").removeClass("comparsion-header--shown");
      }
    }
  })
}
function initComparsionInnerAccordeons() {
  $(".comparsion__section__unit--expandable").each(function () {
    let section = $(this),
      activeClass = 'comparsion__section__unit--expandable--active',
      title = section.find(".comparsion__section__unit__title"),
      cols = section.find(".comparsion__col:not(.comparsion__col--first)");
    title.on("click", function () {
      section.toggleClass(activeClass);
      if (section.hasClass(activeClass)) {
        var innerHeight = findTallestCol(cols);
        cols.css("max-height", innerHeight + "px");
      } else {
        cols.css("max-height", 0 + "px");
      }
      hideScroll();
    })
  })
}
function initComparsionTablesScrollSync() {
  const compHeader = document.querySelector(".comparsion-header__wrap");
  const compTable = document.querySelector(".comparsion__table");
  const scrollObj = document.querySelector(".scroll-obj");
  if(!!/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
    if (!!compHeader && !!compTable) {
      // light for optimization in IOS (not visible scrollObj)
      syncScroll(compHeader, compTable);
    }
  } else {
    if (!!compHeader && !!compTable && !!scrollObj) {
      syncScroll(compHeader, scrollObj, compTable);
    }
  }
}
function syncScroll(...syncElems) {
  let isBlocked = false;
  const scrollEnd = debounce((activeElem) => {
    for (const syncEl of syncElems) {
      syncEl.style.willChange = "auto";
      if (syncEl !== activeElem) syncEl.addEventListener("scroll", onCheckScroll);
    }
    isBlocked = false;
  }, 250);

  for (const syncEl of syncElems) {
    syncEl.addEventListener("scroll", onCheckScroll);
  }

  function onCheckScroll(e) {
    if (!isBlocked) {
      for (const syncEl of syncElems) {
        syncEl.style.willChange = 'scroll-position';
        if (syncEl !== e.target) syncEl.removeEventListener("scroll", onCheckScroll);
      }
      isBlocked = true;
    }
    runScroll(e.target);
    scrollEnd(e.target);
  }
  function runScroll(el) {
    window.requestAnimationFrame(() => {
      for (const syncEl of syncElems) {
        if (syncEl !== el) {
          syncEl.scrollLeft = Math.round(Number(el.scrollLeft));
        } // round for optimization
        //if (syncEl !== el) syncEl.scrollLeft = el.scrollLeft;
      }
    });
  }
};

function initComparsionAccordeons() {
  $(".comparsion__section").each(function () {
    let section = $(this),
      activeClass = 'comparsion__section--active',
      title = section.find(".comparsion__section__title"),
      body = section.find(".comparsion__section__body"),
      bodyInner = section.find(".comparsion__section__body__inner");
    title.on("click", function () {
      section.toggleClass(activeClass);
      if (section.hasClass(activeClass)) {
        var bodyHeight = bodyInner.innerHeight();
        let totalHeight = bodyHeight;
        section.find('.comparsion__section__unit--expandable').each(function () {
          let columns = $(this).find(".comparsion__col:not(.comparsion__col--first)");
          totalHeight = totalHeight + findTallestCol(columns) + 30;
        })
        body.css("max-height", totalHeight + "px");
        clearTimeout(sectionTimeout);
        sectionTimeout = setTimeout(function () {
          //body.css("overflow", 'visible');
          hideScroll()
        }, 300)
      } else {
        body.css({ "max-height": 0 + "px" });
        //body.css({ "max-height": 0 + "px", 'overflow': 'hidden' });
      }
    })
  })
}
function initComparsionTableResizeEvents() {
  $(".comparsion__section--active").each(function () {
    let section = $(this),
      body = section.find(".comparsion__section__body"),
      bodyInner = section.find(".comparsion__section__body__inner");
    let currentHeight = body.innerHeight();
    var bodyHeight = bodyInner.innerHeight();
    let totalHeight = bodyHeight;
    section.find('.comparsion__section__unit--expandable').each(function () {
      let columns = $(this).find(".comparsion__col:not(.comparsion__col--first)");
      totalHeight = totalHeight + findTallestCol(columns) + 30;
    })
    if (currentHeight !== totalHeight) {
      body.css("max-height", totalHeight + "px");
      //setTimeout(function () {
        //body.css("overflow", 'visible');
      //}, 300)
    }
  })
  $(".comparsion__section__unit--expandable--active").each(function () {
    let section = $(this),
      cols = section.find(".comparsion__col:not(.comparsion__col--first)");
    let colsCurrentHeight = 0;
    cols.each(function () {
      if ($(this).outerHeight(true) > colsCurrentHeight) {
        colsCurrentHeight = $(this).outerHeight(true);
      }
    })
    var innerHeight = findTallestCol(cols);
    if (colsCurrentHeight !== innerHeight) {
      cols.css("max-height", innerHeight + "px");
    }

  })

  setTimeout(function () {
    hideScroll()
  }, 300)
}
function initComparsionPage() {
  initComparsionAccordeons();
  initComparsionInnerAccordeons();
  showComparsionHeader();
  initComparsionTablesScrollSync();
}
let flag = true
$(window).on("load scroll", function () {
  var scroll = window.pageYOffset;

  if ($(".js-when-to-show-shortview").length > 0) {
    var priceBlock = $(".item__price");
    if (scroll > priceBlock.offset().top + priceBlock.outerHeight()) {
      $(".item-shortview").addClass("item-shortview--shown");
    } else {
      $(".item-shortview").removeClass("item-shortview--shown");
    }
  }
  if (scroll > 0) {
    $(".header").addClass("header--scrolled")
  } else {
    $(".header").removeClass("header--scrolled")
  }



    if(flag) {
        document.querySelectorAll(".new-year__flake").forEach(flake => {
            setTimeout(() => {
                flake.style.opacity = "1"
                flake.style.transform = "translateY(0)"
            }, 300)
        })
        flag = false
    } else {
        document.querySelectorAll(".new-year__flake").forEach((flake, i) => {
            flake.style.transition = "transform 0s"
            flake.style.transform = `translateY(${window.pageYOffset / 30 * ((i + 1) * 2)}px)`
        })
    }
})
function getCoords(elem) {
  let box = elem.getBoundingClientRect();

  return {
    top: box.top + pageYOffset,
    left: box.left + pageXOffset
  };
}

function stickBasketSidebarCard(width) {
  if (width < 1201) {
    $(".basket__sidebar__card--fixed").trigger("sticky_kit:detach");
  } else {
    $(".basket__sidebar__card--fixed").stick_in_parent({
      parent: ".basket",
      spacer: false
    });
  }
}
function initAltAccordeons() {
  $('.tarif-accordion-h').each(function () {
    let body = $(this).next('.tarif-accordion-c');
    let bodyInner = body.find('.tarif-tr');
    $(this).on('click', () => {
      $(this).toggleClass('active');
      let height = $(this).hasClass('active') ? bodyInner.outerHeight(true) : 0;
      body.css('max-height', `${height}px`);
    })
  })
}
function wrapTextTables() {
  let tables = document.querySelectorAll('.text-wrap table');
  tables.forEach((table) => {
    const hasWrap = table.closest('.table__wrap');
    if (!hasWrap) {
      $(table).wrap('<div class="table__wrap"></div>')
    }
  })
}
function openActiveFilters() {
  $(".products-filters__section--active").each(function () {
    var section = $(this),
      body = section.find(".products-filters__section__body"),
      bodyInner = section.find(".products-filters__section__body__inner");
    var innerHeight = bodyInner.outerHeight(true);
    body.css("max-height", innerHeight + "px");
  })
}
function initProfileSidebarStick(width) {
  if (width < 767) {
    $(".profile__sidebar__wrap").trigger("sticky_kit:detach");
  } else {
    $(".profile__sidebar__wrap").stick_in_parent({
      offset_top: 20
    });
  }
}
$(window).on("load resize", function () {
  var width = window.innerWidth;
  if (width > 767) {
    $(".profile__section__body").removeAttr("style");
    $(".profile__section").removeClass("profile__section--active");
  }
  if ($("header").hasClass("header--list")) {
    if (width < 1201 && width > 767) {
      $(".header__main").stick_in_parent({
        parent: "body"
      });
      $(".header__main").css("background", "#FFF");
      $(".header__main").css("z-index", "17");
      $(".header-catalog").css("top", "calc(100% + 12px)");
    } else {
      $(".header__main").trigger("sticky_kit:detach");
      $(".header__main").css("background", "");
      $(".header__main").css("z-index", "");
      $(".header-catalog").css("top", "");
    }
  }
  initComparsionTableResizeEvents();
  stickBasketSidebarCard(width);
  // initProfileSidebarStick(width);
  addMainSliderBgImage();
  openActiveFilters();

  if($(".comparsion__table__wrap").length) {
    let compareWidth = $(".comparsion__table__wrap").outerWidth();
    $('.scroll-objWidth').css({
      'min-width': compareWidth + 'px'
    })
    $(".comparsion-header__wrap__inner").css({
      "min-width": compareWidth + "px",
    });
  }
})

$('[data-fancybox]').fancybox({
  hideScrollbar: false,
  baseClass: "mts-world",
  animationEffect: "zoom-in-out",
  animationDuration: 500,
  transitionDuration: 300,
});



//amorf animation
productInfoAmorphous = {
  init: function () {
      var o = this, t = $(".js__amorphous-info");
      o.generatePathes("image"), o.generatePathes("bg"), t.each(function (t, e) {
          o.initMedia(e)
      })
  },
  options: {
      time: {
          get delay0() {
              return $(window).width() < 760 ? 0 : 1200
          }, get step1() {
              return $(window).width() < 760 ? 0 : 1500
          }, step2: 4e3
      }, path: {begin: "M", end: "Z"}
  },
  initMedia: function (t) {
      var e = this;
      navigator.userAgent.match(/Trident/) && navigator.userAgent.match(/rv[ :]11/) && $(t).addClass("is-ie"), setTimeout(function () {
          e.addPathes(t), e.showWrapper()
      }, e.options.time.delay0)
  },
  showWrapper: function () {
      $(".js__amorphous-info").addClass("is-init")
  },
  generatePathes: function (t) {
      var e = {image: {raw: this.imageRaw, dist: "imagePathes"}, bg: {raw: this.bgRaw, dist: "bgPathes"}};
      this[e[t].dist] = e[t].raw.map(function (t) {
          return "M" + t.split("C").map(function (o) {
              var i = 200 * Math.random() - 100;
              return o = o.split(" ").map(function (t, e) {
                  return t = parseFloat(t), 2 < o.length && e <= 1 && (2 !== e && 3 !== e || (t += i)), t
              })
          }).join("C") + "Z"
      })
  },
  imageRaw: ["160.407 9.18041C200.091 13.2754 241.58 20.5461 267.833 50.5855C294.723 81.3538 300.104 124.25 296.551 164.958C292.948 206.228 281.383 249.406 248.3 274.34C216.086 298.619 172.762 293.49 132.744 288.415C94.2239 283.53 53.6798 276.336 28.825 246.506C3.82589 216.502 2.80814 175.095 5.8873 136.163C9.04784 96.2019 15.16 53.1586 46.1299 27.708C77.1236 2.23773 120.502 5.06265 160.407 9.18041", "216.375 7.12526C258.318 24.2294 280.644 67.594 292.526 111.184C304.067 153.519 304.251 199.837 278.63 235.507C253.236 270.861 209.326 285.118 165.778 287.645C122.371 290.164 78.8582 279.472 48.0491 248.889C15.0742 216.156 -6.61297 170.517 1.82993 124.9C10.1265 80.0733 48.8465 50.1362 88.9042 28.1465C128.595 6.35841 174.438 -9.97696 216.375 7.12526", "193.346 22.7164C231.533 38.6897 273.924 54.1511 290.632 91.993C308.144 131.655 299.312 178.277 278.927 216.544C259.421 253.163 224.682 279.038 184.818 290.637C147.204 301.582 107.079 295.226 72.6407 276.566C40.0455 258.904 16.4573 228.768 5.3858 193.412C-5.25537 159.429 0.955901 123.98 14.5538 91.0669C29.092 55.8784 47.5575 18.8063 83.1448 5.20158C119.259 -8.60438 157.679 7.7968 193.346 22.7164", "248.946 31.4295C291.164 67.2715 300 126.408 300 162.515C300 198.621 291.057 240.302 248.946 267.275C190.694 304.587 92.3068 302.044 49.3719 279.618C6.43694 257.192 -8.23705 198.177 4.34249 145.531C16.2083 95.8707 35.1811 66.8114 64.495 38.9271C114.18 -8.33448 206.728 -4.41251 248.946 31.4295", "41.5658 32.2939C-6.90819 66.5691 -1.879 122.378 2.95239 155.556C7.78378 188.734 33.3258 240.54 65.3081 266.344C106.272 299.396 162.708 300.441 204.855 286.638C247.003 272.836 276.928 235.636 294.051 180.71C301.892 155.556 310.599 84.7074 258.765 42.4141C195.054 -9.56942 90.0398 -1.98129 41.5658 32.2939", "4.0161 124.478C4.01611 87.8171 28.8195 24.86 132.002 3.59642C235.184 -17.6671 300.98 58.4561 295.705 150.239C291.453 224.219 259.988 293.91 156.805 299.855C118.493 302.062 55.1363 278.975 28.8195 237.433C2.50282 195.89 4.01609 150.239 4.0161 124.478"],
  imagePathes: [],
  bgRaw: ["160.689 11.7847C200.155 22.2877 226.929 49.982 249.492 81.0824C275.476 116.899 311.782 156.355 294.507 196.24C277.074 236.489 221.019 245.023 174.373 254.518C132.326 263.076 86.5254 268.794 51.8706 245.628C17.8039 222.856 13.6356 181.698 8.55386 143.671C2.79521 100.58 -12.8712 50.5245 21.7829 20.4827C57.0281 -10.0714 113.846 -0.68163 160.689 11.7847", "160.407 9.18041C200.091 13.2754 241.58 20.5461 267.833 50.5855C294.723 81.3538 300.104 124.25 296.551 164.958C292.948 206.228 281.383 249.406 248.3 274.34C216.086 298.619 172.762 293.49 132.744 288.415C94.2239 283.53 53.6798 276.336 28.825 246.506C3.82589 216.502 2.80814 175.095 5.8873 136.163C9.04784 96.2019 15.16 53.1586 46.1299 27.708C77.1236 2.23773 120.502 5.06265 160.407 9.18041", "216.375 7.12526C258.318 24.2294 280.644 67.594 292.526 111.184C304.067 153.519 304.251 199.837 278.63 235.507C253.236 270.861 209.326 285.118 165.778 287.645C122.371 290.164 78.8582 279.472 48.0491 248.889C15.0742 216.156 -6.61297 170.517 1.82993 124.9C10.1265 80.0733 48.8465 50.1362 88.9042 28.1465C128.595 6.35841 174.438 -9.97696 216.375 7.12526", "193.346 22.7164C231.533 38.6897 273.924 54.1511 290.632 91.993C308.144 131.655 299.312 178.277 278.927 216.544C259.421 253.163 224.682 279.038 184.818 290.637C147.204 301.582 107.079 295.226 72.6407 276.566C40.0455 258.904 16.4573 228.768 5.3858 193.412C-5.25537 159.429 0.955901 123.98 14.5538 91.0669C29.092 55.8784 47.5575 18.8063 83.1448 5.20158C119.259 -8.60438 157.679 7.7968 193.346 22.7164", "248.946 31.4295C291.164 67.2715 300 126.408 300 162.515C300 198.621 291.057 240.302 248.946 267.275C190.694 304.587 92.3068 302.044 49.3719 279.618C6.43694 257.192 -8.23705 198.177 4.34249 145.531C16.2083 95.8707 35.1811 66.8114 64.495 38.9271C114.18 -8.33448 206.728 -4.41251 248.946 31.4295", "41.5658 32.2939C-6.90819 66.5691 -1.879 122.378 2.95239 155.556C7.78378 188.734 33.3258 240.54 65.3081 266.344C106.272 299.396 162.708 300.441 204.855 286.638C247.003 272.836 276.928 235.636 294.051 180.71C301.892 155.556 310.599 84.7074 258.765 42.4141C195.054 -9.56942 90.0398 -1.98129 41.5658 32.2939", "4.0161 124.478C4.01611 87.8171 28.8195 24.86 132.002 3.59642C235.184 -17.6671 300.98 58.4561 295.705 150.239C291.453 224.219 259.988 293.91 156.805 299.855C118.493 302.062 55.1363 278.975 28.8195 237.433C2.50282 195.89 4.01609 150.239 4.0161 124.478"],
  bgPathes: [],
  randomPathes: function (t) {
      return (t ? this.imagePathes : this.bgPathes).sort(function (t, e) {
          return .5 <= Math.random() ? -1 : 1
      })
  },
  addPathes: function (t) {
      var o = this, e = $(t), i = e.find(".js__amorphous-info-svg"), n = e.find(".js__amorphous-info-image"),
          a = e.find(".js__amorphous-info-path"), s = e.find(".js__amorphous-info-mask"), r = this.randomPathes(),
          c = this.randomPathes(!0)[0];
      o.setImagePosition(i, n), a.each(function (t, e) {
          o.animationSetPath($(e), r[t])
      }), o.animationSetPath(s, c), o.animationImage(n)
  },
  animationImage: function (t) {
  },
  animationSetPath: function (i, t) {
      var n = this, e = 90 * Math.round(4 * Math.random()), o = .5 < Math.random() ? 1 : -1,
          a = i.closest(".js__amorphous-info").hasClass("is-top-tariff") ? 0 : .25,
          s = {scaleProp: .6 + a, rotateProp: (65 + e) * o};
      i[0].rotateProp = s.rotateProp, i[0].scaleProp = s.scaleProp, i.css({
          "-webkit-transform-origin": "center",
          "-moz-transform-origin": "center",
          "-o-transform-origin": "center",
          "-ms-transform-origin": "center",
          "transform-origin": "center"
      }).css(n.getTransform(s.scaleProp, s.rotateProp)).attr("d", t).animate({
          scaleProp: .6 + a,
          rotateProp: (3 + e) * o
      }, {
          duration: n.options.time.step1, step: function (t, e) {
              s[e.prop] = t, i.css(n.getTransform(s.scaleProp, s.rotateProp));
              var o = getComputedStyle(i[0]).getPropertyValue("transform");
              i[0].setAttribute("transform", o)
          }, complete: function () {
              i.animate({scaleProp: .67 + a, rotateProp: (e - 10) * o}, {
                  duration: n.options.time.step2,
                  step: function (t, e) {
                      s[e.prop] = t, i.css(n.getTransform(s.scaleProp, s.rotateProp));
                      var o = getComputedStyle(i[0]).getPropertyValue("transform");
                      i[0].setAttribute("transform", o)
                  }
              })
          }
      })
  },
  getTransform: function (t, e) {
      return {
          "-webkit-transform": "scale(" + t + ") rotateZ(" + e + "deg)",
          "-moz-transform": "scale(" + t + ") rotateZ(" + e + "deg)",
          "-o-transform": "scale(" + t + ") rotateZ(" + e + "deg)",
          "-ms-transform": "scale(" + t + ") rotateZ(" + e + "deg)",
          transform: "scale(" + t + ") rotateZ(" + e + "deg)"
      }
  },
  setImagePosition: function (t, e) {
      var o = e.hasClass("js__amorphous-info-top") ? 1 : 1240 / 770, i = t.attr("width"), n = i * o,
          a = -1 * (n - i) / 2, x = e.attr("x");
      e.attr("width", n), e.attr("height", i)
  }
};
$(function () {
  productInfoAmorphous.init();
});

//amorf animation end


//DRAG COMPARE

$(function () {
const sliderHero = document.querySelectorAll('.scroll-grab');


sliderHero.forEach((slider)=>{
  let isDown = false;
  let startX;
  let scrollLeft;
  slider.addEventListener('mousedown', (e) => {
    let rect = slider.getBoundingClientRect();
    isDown = true;
    slider.classList.add('active');
    // Get initial mouse position
    startX = e.pageX - rect.left;
    // Get initial scroll position in pixels from left
    scrollLeft = slider.scrollLeft;
  });
  
  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.dataset.dragging = false;
    slider.classList.remove('active');
  });
  
  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.dataset.dragging = false;
    slider.classList.remove('active');
  });
  
  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    let rect = slider.getBoundingClientRect();
    e.preventDefault();
    slider.dataset.dragging = true;
    // Get new mouse position
    const x = e.pageX - rect.left;
    // Get distance mouse has moved (new mouse position minus initial mouse position)
    const walk = (x - startX);
    // Update scroll position of slider from left (amount mouse has moved minus initial scroll position)
    slider.scrollLeft = scrollLeft - walk;
  });
})
});



function hideScroll() {
  $('.hide-scroll').waypoint({
    handler: function(direction) {
      if(direction === 'down') {
        $('.scroll-obj-container').hide()
      } else if(direction === 'up') {
        $('.scroll-obj-container').show()
      }
    },
    offset: 'bottom-in-view'
  })
  $('.comparsion__table__wrap').waypoint({
    handler: function(direction) {
      $('.scroll-obj-container').show()
    },
    offset: '50%'
  })
}
if(window.matchMedia('(max-width: 767px)').matches){
	$('.mobile-show-tariffs__list').on('click', function(){
    $('.tariffs__list--hide-mobile').slideToggle();
  })
}


document.addEventListener("DOMContentLoaded", () => {
  jQuery.fn.extend({
    toggleText: function(stateOne, stateTwo) {
        return this.each(function() {
            stateTwo = stateTwo || '';
            $(this).text() !== stateTwo  && stateOne
            ? $(this).text(stateTwo)
            : $(this).text(stateOne);
        });  
    }
  });
  
  
  
  
  $(".products__sidebar-mb-head").on('click', function(){
    $('.products__sections').slideToggle();
    $(this).toggleClass('is-active');
    $('.products__sidebar-mb-head-name').toggleText('Отобразить все разделы', 'Скрыть все разделы');
  })

  $(".products-filters__result__remove").on('click', function(){
    let $this = $(this);
    $this.parents(".products-filters__result").addClass('is-active');
    setTimeout(function(){
      $this.parents(".products-filters__result").removeClass('is-active');
    }, 3000);
  });

if($('#installment-tel').length) {
  let element
  let maskOptions
  let mask
  element = document.getElementById('installment-tel');
  maskOptions = {
      mask: '+ 375 (00) 000-00-00',
      lazy: false
  } 
  mask = new IMask(element, maskOptions);
}


  $('.installment-tel-check-show-modal').on('click', function(){
    $.fancybox.close();
    $.fancybox.open( $('#installment-modal-thanks'),{
      hideScrollbar: false,
      baseClass: "mts-installment",
      animationEffect: "zoom-in-out",
      animationDuration: 500,
      transitionDuration: 300,
    });
  });
  $('.show-installment-good').on('click', function(e){
    e.preventDefault();
    $.fancybox.close();
    $.fancybox.open( $('#installment-good'),{
      hideScrollbar: false,
      baseClass: "mts-installment",
      animationEffect: "zoom-in-out",
      animationDuration: 500,
      transitionDuration: 300,
    });
  });
  $('.show-installment-bad').on('click', function(e){
    e.preventDefault();
    $.fancybox.close();
    $.fancybox.open( $('#installment-bad'),{
      hideScrollbar: false,
      baseClass: "mts-installment",
      animationEffect: "zoom-in-out",
      animationDuration: 500,
      transitionDuration: 300,
    });
  });
})




$(function () {

  let sliderItems = document.querySelectorAll(".products-popuplar__slider")

  sliderItems.forEach(sliderItem => {
    let _this = sliderItem;
    let slider = _this.querySelector(".products-popuplar__body");
    let prevArrow = _this.querySelector(".products-popuplar__controls__prev");
    let nextArrow = _this.querySelector(".products-popuplar__controls__next");
  
    let params = {
      loop: true,
      slidesPerView: 4,
      spaceBetween: 46,
      navigation: {
        nextEl: nextArrow,
        prevEl: prevArrow,
      },
  
      breakpoints: {
        767: {
          slidesPerView: "auto",
          spaceBetween: 20,
        }
      }
  
    };
    let sliderEntity = new Swiper(slider, params);
  })
  

  jQuery('.eq-h').matchHeight({
      property: 'min-height',
      byRow: false
  });

  $('.view-presentation__header').on("click", function(){
    $(this).toggleClass('is-active').parents('.view-presentation').find('.view-presentation__body').slideToggle();
  })
  $('.hide-present .btn').on("click", function(e){
    e.preventDefault();
    $('.view-presentation__header').removeClass('is-active')
    $('.view-presentation__body').slideUp();
    $( 'html, body' ).animate({
      scrollTop: $( '.view-presentation' ).offset().top - 140
    }, '300' );
    
  })


  $( '[href*="#"]:not([class])' ).on( 'click', function(e){
    let href = $(this).attr( 'href' ).substring(1);
    $( 'html, body' ).animate({
      scrollTop: $( `[name="${href}"]` ).offset().top
    }, '300' );
    e.preventDefault();
  });

  $( '[href="#top"]' ).on( 'click', function(e){
    $('.details__item').eq(0).addClass("active").find('.details__info').slideDown('slow').addClass("active");
    e.preventDefault();
  });

})

class HeaderSearch {
  constructor(el) {
    this.el = el;
    this.isOpened = false;
    this.headerEl = document.querySelector("header");
    this.wrapper = el.querySelector(".header-search__wrapper");
    this.input = el.querySelector(".header-search__input");
    this.nothingEl = el.querySelector(".header-search__nothing");
    this.fakeValueEl = el.querySelector(".fake-value");
    this.btn = document.querySelector(".header__search");
    this.mobileBtn = document.querySelector("form.menu-mobile__search");
    this.closeBtn = el.querySelector(".header-search__reset");
    this.overlay = document.querySelector(".header-overlay");

    this.keyUpHandler = this.keyUpHandler.bind(this);
    this.overlayHandler = this.overlayHandler.bind(this);
    this.update();
    this.events();
  }
  open() {
    if (!this.isOpened) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      if (!isBodyFixed) bodyFix(true);
      this.el.classList.add("opened");
      this.headerEl.classList.add("search--opened");
      this.input.focus();
      setTimeout(() => {
        if (this.overlay) this.overlay.classList.add("opened");
        this.isOpened = true;
        this.input.focus();
      }, 500);

      document.addEventListener("keydown", this.keyUpHandler);
      window.addEventListener("click", this.overlayHandler);
    }
  }
  close() {
    if (this.isOpened) {
      if (!!isBodyFixed) bodyFix(false);
      if (this.overlay) this.overlay.classList.remove("opened");
      
      document.removeEventListener("keydown", this.keyUpHandler);
      window.removeEventListener("click", this.overlayHandler);
      setTimeout(() => {
        this.el.classList.remove("opened");
        this.isOpened = false;
      }, 100);
      setTimeout(() => {
        this.headerEl.classList.remove("search--opened");
      }, 250);
    }
  }
  updateFake() {
    this.fakeValueEl.innerText = this.input.value;
  }
  update() {
    this.updateFake();
  }

  keyUpHandler(e) {
    if (e.key === "Escape") {
      this.close()
    }
  }
  overlayHandler(e) {
    if (!e.composedPath().includes(this.wrapper) && !e.composedPath().includes(this.btn)) {
      this.close();
    }
  }
  events() {
    document.addEventListener("click", (e) => {
      if (e.target.closest(".fake-search__btn")) {
        e.preventDefault();
        this.open();
      }
    })
    this.input.addEventListener("input", () => {
      this.update();
    });
    if (this.btn) this.btn.addEventListener("click", (e) => {
      if (!e.target.classList.contains('header__filters')) {
        e.preventDefault();
        this.open();
      }
    });
    if (this.mobileBtn) this.mobileBtn.addEventListener("click", (e) => {
      if (!e.target.classList.contains("header__filters")) {
        e.preventDefault();
        this.open();
      }
    });
    if (this.closeBtn) this.closeBtn.addEventListener("click", (e) => {
      //e.preventDefault();
      this.close();
    });
  }
}

function checkVH() {
  vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
}
// Cookies
function cookieSettings() {
  let isAnimated = false;
  document.addEventListener("cookieOpenSettings", openSettings);
  document.addEventListener("cookieCloseSettings", closeSettings);
  function openSettings() {
    if (isAnimated) return;
    $(".cookie__cancel").addClass("back").text("Назад");
    $(".cookie__main").slideUp(400, function() {
      //$(".cookie__setting").addClass("active");
    });
    $(".cookie__more").slideDown(400, function() {
      $(".cookie__settings").addClass("active");
    });
  }
  function closeSettings() {
    if (isAnimated) return;
    $(".cookie__main").slideDown(400, function() {
      //$(".cookie__setting").addClass("active");
    });
    $(".cookie__more").slideUp(400, function() {
      $(".cookie__settings").removeClass("active");      
      $(".cookie__cancel").removeClass("back").text("Отклонить");
    });
  }
  window.addEventListener("click", (e) => {
    if (e.target.closest(".cookie__settings")) {
      const btn = e.target.closest(".cookie__settings");
      if (!btn.classList.contains("active")) {
        openSettings();
      } else {
        closeSettings();
      }
    }
    if (e.target.closest(".cookie__cancel")) {
      if (e.target.closest(".cookie__cancel").classList.contains("back")) {
        closeSettings();
      }
    }
  });
}

/*if (document.querySelector(".products-popular__body") || document.querySelector(".products-popuplar__body")) {

  $('.products-popuplar__body').imagesLoaded( function() {
    $('.swiper-logos-mb img').each(function(){
      let tWidth = $(this).width();
      $(this).parents('.swiper-slide').css({
          'width': tWidth + 'px'
      })
    })
  
    const swiperLogoSl = new Swiper('.swiper-logos-mb', {
      autoplay: {
          delay: 0,
          disableOnInteraction: false
      },
      slidesPerView: 'auto',
      spaceBetween: 40,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return `<div class="${className}"><div data-anim="base wrapper" class="bull-wrapper"><div data-anim="base left" class="circle-left bul-circle"></div><div data-anim="base right" class="circle-right bul-circle"></div></div></div>`;
        },
      },
      speed: 2000,
      observer: true
    });
  });
}*/

/*(function ($) {
  // requestAnimationFrame Polyfill
  (function () {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];

    for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
      window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
      window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame)
      window.requestAnimationFrame = function (callback, element) {
        var currTime = new Date().getTime();
        var timeToCall = Math.max(0, 16 - (currTime - lastTime));
        var id = window.setTimeout(function () {
          callback(currTime + timeToCall);
        },
          timeToCall);
        lastTime = currTime + timeToCall;

        return id;
      };

    if (!window.cancelAnimationFrame)
      window.cancelAnimationFrame = function (id) {
        clearTimeout(id);
      };
  }());

  // Sakura function.
  $.fn.sakura = function (options) {
    // We rely on these random values a lot, so define a helper function for it.
    function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    // Helper function to attach cross-browser events to an element.
    var prefixes = ['moz', 'ms', 'o', 'webkit', ''];
    var prefCount = prefixes.length;

    function prefixedEvent(element, type, callback) {
      for (var i = 0; i < prefCount; i++) {
        if (!prefixes[i]) {
          type = type.toLowerCase();
        }

        element.get(0).addEventListener(prefixes[i] + type, callback, false);
      }
    }

    // Defaults for the option object, which gets extended below.
    var defaults = {
      blowAnimations: ['blow-soft-left', 'blow-medium-left', 'blow-hard-left', 'blow-soft-right', 'blow-medium-right', 'blow-hard-right'],
      className: 'sakura',
      fallSpeed: 3,
      maxSize: 14,
      minSize: 9,
      newOn: 300,
      swayAnimations: ['sway-0', 'sway-1', 'sway-2', 'sway-3', 'sway-4', 'sway-5', 'sway-6', 'sway-7', 'sway-8']
    };

    var options = $.extend({}, defaults, options);

    // Declarations.
    //var documentHeight = $(document).height();
    //var documentWidth = $(document).width();
    var documentHeight = window.innerHeight;
    var documentWidth = window.innerWidth;
    var sakura = $('<div class="' + options.className + '" />');

    // Set the overflow-x CSS property on the body to prevent horizontal scrollbars.
    //$('.chinany-sakura').css({ 'overflow-x': 'hidden' });

    // Function that inserts new petals into the document.
    var petalCreator = function () {
      setTimeout(function () {
        requestAnimationFrame(petalCreator);
      }, options.newOn);

      // Get one random animation of each type and randomize fall time of the petals.
      var blowAnimation = options.blowAnimations[Math.floor(Math.random() * options.blowAnimations.length)];
      var swayAnimation = options.swayAnimations[Math.floor(Math.random() * options.swayAnimations.length)];
      var fallTime = (Math.round(documentHeight * 0.007) + Math.random() * 5) * options.fallSpeed;

      var animations = 'fall-sakura ' + fallTime + 's linear 0s 1' + ', ' +
        blowAnimation + ' ' + (((fallTime > 30 ? fallTime : 30) - 20) + getRandomInt(0, 20)) + 's linear 0s infinite' + ', ' +
        swayAnimation + ' ' + getRandomInt(2, 4) + 's linear 0s infinite';
      var petal = sakura.clone();
      var size = getRandomInt(options.minSize, options.maxSize);
      var startPosLeft = Math.random() * documentWidth - 100;
      //var startPosTop = -((Math.random() * 20) + 15);
      var startPosTop = ((Math.random() * 20) + 15);

      // Apply Event Listener to remove petals that reach the bottom of the page.
      prefixedEvent(petal, 'AnimationEnd', function () {
        $(this).remove();
      });

      // Apply Event Listener to remove petals that finish their horizontal float animation.
      prefixedEvent(petal, 'AnimationIteration', function (ev) {
        if ($.inArray(ev.animationName, options.blowAnimations) != -1) {
          $(this).remove();
        }
      });

      petal
        .css({
          '-webkit-animation': animations,
          '-o-animation': animations,
          '-ms-animation': animations,
          '-moz-animation': animations,
          animation: animations,
          height: size,
          left: startPosLeft,
          'margin-top': startPosTop,
          width: size
        })
        .appendTo('.chinany-sakura');
    };


    // Recalculate documentHeight and documentWidth on browser resize.
    $(window).resize(function () {
      documentHeight = $(document).height();
      documentWidth = $(document).width();
    });

    // Finally: Start adding petals.
    requestAnimationFrame(petalCreator);
  };
}(jQuery));*/
function initCardsProduct() {
  const cardProducts = Array.from(document.querySelectorAll(".card-product"));
  let zIndex = 4;
  function getZIndex() {
    if (zIndex < 15) return zIndex++;
    if (zIndex >= 15) {
      zIndex = 6;
      return zIndex;
    }
  };
  cardProducts.forEach((cardProduct) => {
    if (!cardProduct.classList.contains("is-slider-inited")) {
      cardProduct.classList.add("is-slider-inited");
      const sliderWrapper = cardProduct.querySelector(".card-product__slider");
      if (sliderWrapper) {
        const sliderAction = sliderWrapper.querySelector(".swiper");
        const slides = sliderWrapper.querySelectorAll(".swiper-slide");
        if (sliderAction && slides.length > 1) {
          const prevBtn = sliderWrapper.querySelector(".swiper-button-prev");
          const nextBtn = sliderWrapper.querySelector(".swiper-button-next");
          const swiper = new Swiper(sliderAction, {
            loop: true,
            spaceBetween: 30,
            navigation: {
              nextEl: nextBtn,
              prevEl: prevBtn,
            },
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
              renderBullet: function (index, className) {
                return `<div class="${className}"></div>`;
              },
            },
          })
        }
      }
    }
    if (!cardProduct.classList.contains("is-events-inited") && !cardProduct.closest(".products-list--alt")) {
      cardProduct.classList.add("is-events-inited");
      $(cardProduct).hover(function () {
        const card = $(this);
        const additional = card.find(".card-product__additional");
        card.css("z-index", getZIndex());
        if (!card.hasClass("is-enter")) {
          card.addClass("is-enter");
          additional.slideDown(300, function () { // Открытие
            card.removeClass("is-enter");
          });
        }
      }, function () {
        const card = $(this);
        const additional = card.find(".card-product__additional");
        additional.slideUp(300, function () { // Закрытие
          if (!card.is(":hover")) {
            card.css("z-index", "unset");
          } else {
            additional.slideDown(300, function () { // Открытие
              card.removeClass("is-enter");
            });
          }
        });        
      });
    }

  });
  alignFootersCardsProduct();
  window.addEventListener("resize", (e) => {
    alignFootersCardsProduct();
  });
}

function alignFootersCardsProduct() {
  const cards = Array.from(document.querySelectorAll(".card-product"));
  const lines = {};
  cards.forEach((el) => {
    const top = el.offsetTop;
    if (lines[top] && lines[top].length) {
      lines[top].push(el);
    } else {
      lines[top] = new Array();
      lines[top].push(el);
    }
  });
  for (const key in lines) {
    if (Object.hasOwnProperty.call(lines, key)) {
      const element = lines[key];
      let isEmpty = false;
      element.forEach((card) => {
        if (card.querySelector(".card-product__pre-btn")) {
          isEmpty = true;
        }
      });
      if (!isEmpty) {
        element.forEach((card) => card.classList.add("is-not-prebtn"));
      } else {
        element.forEach((card) => card.classList.remove("is-not-prebtn"));

      }
    }
  }
  // card-product__pre-btn
}